import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
  DropDownSearchDraw,
  TableLayoutData,
} from "../../styledElements.js";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Radio,
  Tabs,
  Tooltip,
  Table,
  Switch,
  Result,
  Checkbox,
  Collapse,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon.js";
import { HaberForm } from "../../styledElements.js";
import {
  GlobalSet,
  StyledTab,
  Styled,
  PaperBlockList,
} from "../../pageStyled.js";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchProductDetails,
  editProduct,
  deleteProduct,
  getPendingQuantityProductSizes,
  getProductDetails,
} from "../../../Services/productServices.js";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox.jsx";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal.jsx";
import {
  getAllGradesForConfig,
  getGradeQualitiesForConfig,
} from "../../../Services/settingsServices.js";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar.jsx";
import { getUnitData } from "../../../Services/measurementService.js";
import {
  lengthUnit,
  weightUnit,
  currency_List,
  CoversionFactorUnitsToCM,
  CoversionFactorCMToUnits,
  conversionFactorUnitsToTonne,
  conversionFactorTonneToUnits,
} from "../../../Utils/Constant/MeasurementUnitList.jsx";
import { toFixedValue } from "../../../Utils/helper/helper.js";
import OrdersTable from "./OrdersTable.jsx";
import CollapsePanel from "antd/lib/collapse/CollapsePanel.js";
import { editQtyToBePlannedForReviewOrder, getOrdersList } from "../../../Services/orderServices.js";
import { getJobCardsDetailsMultistage } from "../../../Services/deckleMatchServices.js";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices.js";

/**
 * Multistage "create new solution" form: stock sizes, rewinder/cutter constraints,
 * and submission payload for the parent deckle results screen.
 */

/** @param {string} [item] @returns {string} First character uppercased */
const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const Panes = Tabs.TabPane;

const runTypes = [
  { label: "All Sizes", value: "allSizes" },
  { label: "Selected Sizes", value: "selectedSizes" },
];
const grainTypeData = [{ label: "Long Grain", value: "long" }, { label: "Short Grain", value: "short" }];

/**
 * Form UI to configure a new deckle solution (sizes, machines, tolerances) and invoke parent submit.
 */
const CreateNewSolutionMultistage = ({
  onClickCreateSolution,
  formValuesForStock,
  jobCardDetails,
  backButtonClicked,
  stockSizesArray,
  setStockSizesArray,
  createNewSolutionFormValuesForSizes,
  ordersIdList,
  updateOrdersIdList,
  type,
  optimizePartition,
  minimizeOverfulfillment,
  onOptimizePartitionChange,
  onMinimizeOverfulfillmentChange,
  unselectedOrders,
  machineData,
  jobId,
  solutionId,
  completeJCDetails,
  dynamicStock = [],
  solutionType = '',
  isFailedJobcard,
}) => {
  const location = useLocation();
  const [form] = Form.useForm();
  const { Option } = Select;
  const deckleWidthData = ["cm", "mm"];
  const [switchTooltip, setSwitchTooltip] = useState(true);
  const [tabKey, setTabKey] = useState();
  const [formValues, setFormValues] = useState({});
  const [reelDiaForCutter, setReelDiaForCutter] = useState({
    min: formValuesForStock?.min_dia_cutter,
    max: formValuesForStock?.max_dia_cutter,
    unit: formValuesForStock?.units_cutter?.maximum_reel_dia
  })
  const [stockSizes, setStockSizes] = useState(stockSizesArray || []);
  const [isAvailableQuantityUsed, setIsAvailableQuantityUsed] = useState(
    stockSizesArray?.length > 0
  );
  const [productData, setProductData] = useState({
    bulk: "",
    gsm: "",
  });
  const [plannedReels, setPlannedReels] = useState(0);
  const [errorText, setErrorText] = useState("");
  const [allowedQuantityerrorText, setAllowedQuantityerrorText] =
    useState(false);
  const [unitData, setUnitData] = useState();
  const [deckleUnit, setDeckleUnit] = useState();
  const [deckleUnitCutter, setDeckleUnitCutter] = useState();
  const [showError, setShowError] = useState({ error: false, message: "" });
  const [showCutterError, setShowCutterError] = useState({ error: false, message: "" });
  const [isSheetReelChanged, setIsSheetReelChanged] = useState(false)
  const [sizeErrorToastr, setSizeErrorToastr] = useState(false);
  const [isDynamicStock, setIsDynamicStock] = useState(false);
  const [orderIdList, setOrderIdList] = useState(
    Array.isArray(ordersIdList)
      ? ordersIdList
      : jobCardDetails?.group?.orders.map((data) => data.order_id)
  );
  const [toleranceModal, setToleranceModal] = useState(false);
  const [globalTolerance, setGlobalTolerance] = useState({
    lower: 0,
    upper: 0,
  });
  const [showAlert, setShowAlert] = useState({
    isOrderChanged: false,
    isToleranceChanged: false,
    isGlobalToleranceChanged: false,
    isGlobalReelODChanged: false,
    isReelODChanged: false,
    toleranceLevel: "",
    isReelOrderChanged: false
  });
  const [isJobCardReelODEditModal, setJobCardReelODEditModal] = useState(false);
  const [globalReelOD, setGlobalReelOD] = useState({
    level: "Order",
    type: "",
    min_reel_od: 0,
    max_reel_od: 0,
    unit: "",
    selectedReelOD: [],
  })
  const [orderToastr, setOrderToastr] = useState(false);
  const didInitRef = useRef(false);
  const didApplyInitialSelectedSizesRef = useRef(false);
  const reelDiaUpdateInFlightRef = useRef(false);
  const lastReelDiaUpdateKeyRef = useRef("");

  useEffect(() => {
    if (!formValuesForStock) return;
    if (!formValuesForStock?.units) return;
    form.setFieldsValue({
      cutters: formValuesForStock?.maximum_cutters,
      min_deckle_length: formValuesForStock?.min_deckle_length,
      max_deckle_length: formValuesForStock?.max_deckle_length,
      min_width: formValuesForStock?.left_edge_trim,
      max_width: formValuesForStock?.right_edge_trim,
      effective_deckle_length:
        formValuesForStock?.effective_deckle_length,
      deckleLengthUnit: formValuesForStock?.units?.deckle_size_ub,
      widthUnit: formValuesForStock?.units?.right_edge_trim,
      min_deckle_length_cutter: formValuesForStock?.min_deckle_length_cutter,
      max_deckle_length_cutter: formValuesForStock?.max_deckle_length_cutter,
      deckleLengthUnit_cutter:
        formValuesForStock?.units_cutter?.deckle_size_ub,
      max_width_cutter: formValuesForStock?.right_edge_trim_cutter,
      min_width_cutter: formValuesForStock?.left_edge_trim_cutter,
      effective_deckle_length_cutter:
        formValuesForStock?.effective_deckle_length_cutter,
      cutters_cutter: formValuesForStock?.maximum_cutters_cutter,
      widthUnit_cutter: formValuesForStock?.units_cutter?.right_edge_trim,
      max_dia_cutter: formValuesForStock?.max_dia_cutter,
      min_dia_cutter: formValuesForStock?.min_dia_cutter,
      max_chop_cutter: formValuesForStock?.max_chop_cutter,
      min_chop_cutter: formValuesForStock?.min_chop_cutter,
      chopUnit: formValuesForStock?.units_cutter?.max_chop_size,
      reel_dia_unit_cutter:
        formValuesForStock?.units_cutter?.maximum_reel_dia,
      max_trim_intermediate_cutter:
        formValuesForStock?.max_trim_intermediate_cutter,
      max_trim_intermediate_unit_cutter:
        formValuesForStock?.units_cutter?.allowed_trim,
    });
    setDeckleUnit(formValuesForStock?.units?.effective_deckle_length);
    setDeckleUnitCutter(formValuesForStock?.units_cutter?.effective_deckle_length);
  }, [form, formValuesForStock, jobId, solutionId]);

  /** Once on mount: workflow settings, form defaults, units, product spec, pending stock sizes (guarded against StrictMode double-invoke). */
  useEffect(() => {
    if (didInitRef.current) return;
    didInitRef.current = true;
    const controller = new AbortController();
    (async () => {
      let deckleMangtSettings = await getWorkflowSettings("deckle_management");

      setIsDynamicStock(deckleMangtSettings?.data?.dynamic_stocks?.value);
      // console.log(formValuesForStock);
      form.setFieldsValue({
        cutters: formValuesForStock?.maximum_cutters,
        min_deckle_length: formValuesForStock?.min_deckle_length,
        max_deckle_length: formValuesForStock?.max_deckle_length,
        min_width: formValuesForStock?.left_edge_trim,
        max_width: formValuesForStock?.right_edge_trim,
        effective_deckle_length:
          formValuesForStock?.effective_deckle_length
        // *
        // CoversionFactorUnitsToCM[
        //   formValuesForStock?.units?.effective_deckle_length
        // ] *
        // CoversionFactorCMToUnits[formValuesForStock?.units.deckle_size_ub]
        ,
        deckleLengthUnit: formValuesForStock?.units.deckle_size_ub,
        widthUnit: formValuesForStock?.units.right_edge_trim,
        min_deckle_length_cutter: formValuesForStock?.min_deckle_length_cutter,
        max_deckle_length_cutter: formValuesForStock?.max_deckle_length_cutter,
        deckleLengthUnit_cutter:
          formValuesForStock?.units_cutter?.deckle_size_ub,
        max_width_cutter: formValuesForStock?.right_edge_trim_cutter,
        min_width_cutter: formValuesForStock?.left_edge_trim_cutter,
        effective_deckle_length_cutter:
          formValuesForStock?.effective_deckle_length_cutter
        // *
        // CoversionFactorUnitsToCM[
        //   formValuesForStock?.units_cutter?.effective_deckle_length
        // ] *
        // CoversionFactorCMToUnits[
        //   formValuesForStock?.units_cutter?.deckle_size_ub
        // ]
        ,
        cutters_cutter: formValuesForStock?.maximum_cutters_cutter,
        widthUnit_cutter: formValuesForStock?.units_cutter?.right_edge_trim,
        max_dia_cutter: formValuesForStock?.max_dia_cutter,
        min_dia_cutter: formValuesForStock?.min_dia_cutter,
        max_chop_cutter: formValuesForStock?.max_chop_cutter,
        min_chop_cutter: formValuesForStock?.min_chop_cutter,
        chopUnit: formValuesForStock?.units_cutter?.max_chop_size,
        reel_dia_unit_cutter:
          formValuesForStock?.units_cutter?.maximum_reel_dia,
        max_trim_intermediate_cutter:
          formValuesForStock?.max_trim_intermediate_cutter,
        max_trim_intermediate_unit_cutter:
          formValuesForStock?.units_cutter?.allowed_trim,
      });
      setDeckleUnit(formValuesForStock?.units.effective_deckle_length);
      setDeckleUnitCutter(formValuesForStock?.units_cutter?.effective_deckle_length);
      const unitResponse = await getUnitData();
      setUnitData(unitResponse.data);
      getProductDetails(jobCardDetails.product.code)
        .then((response) => {
          setProductData({
            bulk: `${response.data.bulk}`,
            gsm: `${response.data.gsm}`,
          });
        })
        .catch((error) => {
          console.log("Error in getting product specification list");
        });
      if (stockSizes.length == 0) {
        getPendingQuantityProductSizes(jobCardDetails.product.code)
          .then((response) => {
            const data = response.data?.map((item) => {
              let size = item.grain === "Long Grain" ? item.width : item.length;
              if (item.type === "reel") {
                size = item.width;
              }

              const processWeight = item.sheet_in_process.sheet_data?.reduce(
                (n, { fulfilled_weight }) => n + fulfilled_weight,
                0
              );
              const completedWeight = item.sheet_completed.sheet_data?.reduce(
                (n, { fulfilled_weight }) => n + fulfilled_weight,
                0
              );
              const productionWeight =
                item.sheet_in_production.sheet_data?.reduce(
                  (n, { fulfilled_weight }) => n + fulfilled_weight,
                  0
                );

              return {
                size: size,
                stockSizeId: item.id,
                stockSize:
                  item.type === "reel"
                    ? +item.width + ' ' + lengthUnit[item.units.width].displayName.toUpperCase()
                    : +item.width + ' ' + lengthUnit[item.units.width].displayName.toUpperCase() + " * " + +item.length + ' ' + lengthUnit[item.units.length].displayName.toUpperCase(),
                length: item.length,
                width: item.width,
                stockDefaultSize:
                  item.units.width ===
                    unitResponse.data.units_management.length.default
                    ? ""
                    : item.type === "reel"
                      ? +(
                        item.width *
                        CoversionFactorUnitsToCM[item.units.width] *
                        CoversionFactorCMToUnits[
                        unitResponse.data.units_management.length.default
                        ]
                      ).toFixed(3) +
                      " " +
                      lengthUnit[
                        unitResponse.data.units_management.length.default
                      ].displayName.toUpperCase()
                      : +(
                        item.width *
                        CoversionFactorUnitsToCM[item.units.width] *
                        CoversionFactorCMToUnits[
                        unitResponse.data.units_management.length.default
                        ]
                      ).toFixed(3) +
                      " * " +
                      +(
                        item.length *
                        CoversionFactorUnitsToCM[item.units.length] *
                        CoversionFactorCMToUnits[
                        unitResponse.data.units_management.length.default
                        ]
                      ).toFixed(3) +
                      " " +
                      lengthUnit[
                        unitResponse.data.units_management.length.default
                      ].displayName.toUpperCase(),
                availableLimit: parseFloat(
                  item.quantity -
                  (item.in_process +
                    item.in_production +
                    item.completed +
                    processWeight +
                    productionWeight +
                    completedWeight) *
                  conversionFactorTonneToUnits[item.units.quantity]
                ).toFixed(3),
                availableDefaultLimit:
                  item.units.quantity ===
                    unitResponse.data.units_management.weight.default
                    ? ""
                    : (
                      parseFloat(
                        item.quantity -
                        (item.in_process +
                          item.in_production +
                          item.completed +
                          processWeight +
                          productionWeight +
                          completedWeight) *
                        conversionFactorTonneToUnits[item.units.quantity]
                      ) *
                      conversionFactorUnitsToTonne[item.units.quantity] *
                      conversionFactorTonneToUnits[
                      unitResponse.data.units_management.weight.default
                      ]
                    ).toFixed(3) +
                    " " +
                    capitalize(
                      weightUnit[
                        unitResponse.data.units_management.weight.default
                      ].displayName
                    ),
                allowedQuantity: parseFloat(
                  item.quantity -
                  (item.in_process +
                    item.in_production +
                    item.completed +
                    processWeight +
                    productionWeight +
                    completedWeight) *
                  conversionFactorTonneToUnits[item.units.quantity]
                ).toFixed(3),
                plannedWeight: parseFloat(
                  item.quantity -
                  (item.in_process +
                    item.in_production +
                    item.completed +
                    processWeight +
                    productionWeight +
                    completedWeight) *
                  conversionFactorTonneToUnits[item.units.quantity]
                ).toFixed(3),
                isSelected: false,
                plannedWeightError: "",
                allowedQuantityError: "",
                units: item.units,
                isGrainChanged: item.rotated,
                type: item.type,
                grain: item.grain,
                availableUnit: item.units.quantity,
                isSelected:
                  solutionType === "replan" &&
                  jobCardDetails?.group?.orders.some((data) => {
                    // Convert both to cm

                    const itemWidthCM = parseFloat(item.width) * CoversionFactorUnitsToCM[item.units.width];
                    const dataWidthCM = parseFloat(data.width) * CoversionFactorUnitsToCM[data.units.width];

                    if (item.type === "reel") {
                      // For reel: compare only length
                      return Math.abs(itemWidthCM - dataWidthCM) < 0.01; // small tolerance
                    } else if (item.type === "sheet") {
                      const itemLengthCM = parseFloat(item.length) * CoversionFactorUnitsToCM[item.units.length];
                      const dataLengthCM = parseFloat(data.length) * CoversionFactorUnitsToCM[data.units.length];
                      // For sheet: compare both
                      return (
                        Math.abs(itemLengthCM - dataLengthCM) < 0.01 &&
                        Math.abs(itemWidthCM - dataWidthCM) < 0.01
                      );
                    }

                    return false;
                  }),

              };
            });
            const stocksData = data?.filter((data) => data.availableLimit > 0);
            const existingDynamicStocks = stockSizes.filter(
              (stock) => stock.isNew || stock.isRequired
            );
            if (solutionType == "replan") {
              if (dynamicStock.length) {
                const allDynamicStocks = [
                  ...existingDynamicStocks,
                  ...dynamicStock,
                ];
                setStockSizes([...stocksData, ...allDynamicStocks]);
              } else {
                setStockSizes([...stocksData, ...existingDynamicStocks]);
              }
            } else if (solutionId == "1" || solutionId == "2") {
              let data =
                solutionId == "1"
                  ? jobCardDetails.solution_1.data.orders
                  : jobCardDetails.solution_2.data.orders;
              const dynamicStockData = data
                ?.filter((order) => {
                  return order.creation_type === "dynamic" || order.creation_type === "required";
                })
                .map((item) => {
                  return {
                    allowedQuantity: item?.requirement,
                    stockSize:
                      item.type === "reel"
                        ? +item.size + ' ' + lengthUnit[item.units.size].displayName.toUpperCase()
                        : +item.size + ' ' + lengthUnit[item.units.size].displayName.toUpperCase() + " * " + +item.lateral_size + ' ' + lengthUnit[item.units.lateral_size].displayName.toUpperCase(),

                    length: item.lateral_size,
                    width: item.size,
                    isSelected: true,
                    ...(item.creation_type === "dynamic" && { isNew: true }),
                    ...(item.creation_type === "required" && {
                      isRequired: true,
                      weight_lb: item.requirement_lb,
                      weight_ub: item.requirement_ub,
                      priority_stock: item.priority_stock,
                    }),
                    isEdit: false,
                    isGrainChanged: item.rotated,
                    type: item.type,
                    grain: item.grain,
                    availableUnit: item.units.quantity,
                    units: {
                      ...item.units,
                      quantity: item?.units?.fulfilled_weight,
                      width: item?.units?.size,
                      length: item?.units?.lateral_size,
                      weight_lb: item?.units?.requirement_lb,
                      weight_ub: item?.units?.requirement_ub,
                    },
                  };
                });

              const allDynamicStocks = [
                ...existingDynamicStocks,
                ...(dynamicStockData || []),
              ];
              if (allDynamicStocks.length) {
                setStockSizes([...stocksData, ...allDynamicStocks]);
              } else {
                setStockSizes([...stocksData, ...existingDynamicStocks]);
              }
            } else {
              setStockSizes([...stocksData, ...existingDynamicStocks]);
            }
          })
          .catch((error) => { });
      }
    })();

    handleCutterReelDiaChange();

    return () => {
      controller.abort();
    }
  }, []);

  /** One-time: when stock rows exist, replay saved `selectedSizes` into allowed-quantity calculations. */
  useEffect(() => {
    // Apply pre-selected sizes exactly once after stock sizes are loaded.
    if (didApplyInitialSelectedSizesRef.current) return;
    if (!stockSizes?.length) return;
    if (!createNewSolutionFormValuesForSizes?.selectedSizes?.length) return;

    didApplyInitialSelectedSizesRef.current = true;
    stockSizes.forEach((stockSize, index) => {
      const sizeDetails =
        createNewSolutionFormValuesForSizes?.selectedSizes?.filter(
          (size) => size.stockSizeId == stockSize.stockSizeId
        );
      if (sizeDetails && sizeDetails.length > 0) {
        onAllowedQuantityChange(
          sizeDetails[0].length,
          sizeDetails[0].width,
          parseFloat(sizeDetails[0].allowedQuantity),
          index
        );
      }
    });
  }, [stockSizes, createNewSolutionFormValuesForSizes]);

  /** Syncs form snapshot to parent state then triggers Ant Design form submit. */
  const onClickCreateSolutionButton = async () => {
    await setUpdatedFormValues();
    form.submit();
  };

  /** Reads current form + selected stock rows into `formValues` for submit and parent callbacks. */
  const setUpdatedFormValues = () => {
    const updatedFormValues = {
      status: form.getFieldValue("status"),
      selectedSizes: [],
      minDeckleLength: form.getFieldValue("min_deckle_length"),
      maxDeckleLength: form.getFieldValue("max_deckle_length"),
      deckleLengthUnit: form.getFieldValue("deckleLengthUnit"),
      minWidth: form.getFieldValue("min_width"),
      maxWidth: form.getFieldValue("max_width"),
      widthUnit: form.getFieldValue("widthUnit"),
      effectiveDeckleLength: form.getFieldValue("effective_deckle_length"),
      cutters: form.getFieldValue("cutters"),
      minDeckleLengthCutter: form.getFieldValue("min_deckle_length_cutter"),
      maxDeckleLengthCutter: form.getFieldValue("max_deckle_length_cutter"),
      deckleLengthUnitCutter: form.getFieldValue("deckleLengthUnit_cutter"),
      minWidthCutter: form.getFieldValue("min_width_cutter"),
      maxWidthCutter: form.getFieldValue("max_width_cutter"),
      widthUnitCutter: form.getFieldValue("widthUnit_cutter"),
      effectiveDeckleLengthCutter: form.getFieldValue(
        "effective_deckle_length_cutter"
      ),
      cuttersCutter: form.getFieldValue("cutters_cutter"),
      widthUnit_cutter: form.getFieldValue("widthUnit_cutter"),
      max_dia_cutter: form.getFieldValue("max_dia_cutter"),
      min_dia_cutter: form.getFieldValue("min_dia_cutter"),
      max_chop_cutter: form.getFieldValue("max_chop_cutter"),
      min_chop_cutter: form.getFieldValue("min_chop_cutter"),
      chopUnit: form.getFieldValue("chopUnit"),
      reel_dia_unit_cutter: form.getFieldValue("reel_dia_unit_cutter"),
      max_trim_intermediate_cutter: form.getFieldValue(
        "max_trim_intermediate_cutter"
      ),
      max_trim_intermediate_unit_cutter: form.getFieldValue(
        "max_trim_intermediate_unit_cutter"
      ),
    };

    const isRewinder =
      jobCardDetails?.group?.machines[0]?.machine_type !== "rewinder";

    stockSizes.forEach((item, index) => {
      if (item.isSelected) {

        let selectedSizes = {
          type: item.type,
          stockSizeId: stockSizes[index].stockSizeId,
          stockSize: item.stockSize,
          allowedQuantity: parseFloat(stockSizes[index].allowedQuantity),
          sheets: item.sheets,
          plannedWeight: parseFloat(stockSizes[index].allowedQuantity),
          rotated: stockSizes[index].isGrainChanged,
          grain: stockSizes[index].grain,
          ...(item.type === 'sheet' && { length: parseFloat(item.length) }),
          mixed_grain: false,
          width: parseFloat(item.width),
          ...(item.isRequired && {
            weight_lb: parseFloat(stockSizes[index].weight_lb),
            weight_ub: parseFloat(stockSizes[index].weight_ub),
            requirement_lb: parseInt(stockSizes[index].lowerSheets),
            requirement_ub: parseInt(stockSizes[index].upperSheets),
            priority_stock: stockSizes[index].priority_stock ? true : false,
          }),
          units: {
            ...(item.type === "sheet" && { length: item.units.length, }),
            width: item.units.width,
            planned_weight: item.units.quantity,
            allowed_quantity: item.units.quantity,
            ...(item.isRequired && {
              weight_lb: item.units.weight_lb,
              weight_ub: item.units.weight_ub,
            }),
          },
          creation_type: item.isNew ? "dynamic" : item.isRequired ? 'required' : "static",

        };

        if (isRewinder) {
          selectedSizes.reels = form.getFieldValue("reels" + index);
        }

        updatedFormValues.selectedSizes.push(selectedSizes);
      }
    });

    setFormValues(updatedFormValues);
  };

  /**
   * When cutter min/max reel OD changes, fetches orders and persists reel OD to backend (deduped).
   * @param {string} [key] Tab key when switching to cutter tab after update.
   */
  const handleCutterReelDiaChange = (key) => {
    const { min_dia_cutter, max_dia_cutter, reel_dia_unit_cutter } = form.getFieldsValue();
    const { min, max, unit } = reelDiaForCutter;

    //if there's an error then skip
    const minDiaErrors = form.getFieldError('min_dia_cutter');
    const maxDiaErrors = form.getFieldError('max_dia_cutter');
    if (minDiaErrors.length || maxDiaErrors.length) return;

    //if there is no change then skip
    if ((min === min_dia_cutter && max === max_dia_cutter && unit === reel_dia_unit_cutter) || (!min_dia_cutter || !max_dia_cutter)) {
      return;
    }
    // Prevent duplicate calls (StrictMode, rapid switching, same payload).
    const updateKey = JSON.stringify({
      min_dia_cutter,
      max_dia_cutter,
      reel_dia_unit_cutter,
      group_id: jobCardDetails?.group?.group_id,
    });
    if (reelDiaUpdateInFlightRef.current) return;
    if (lastReelDiaUpdateKeyRef.current === updateKey) {
      setTabKey(key);
      return;
    }

    reelDiaUpdateInFlightRef.current = true;
    lastReelDiaUpdateKeyRef.current = updateKey;

    //get latest list of orders with cutter_reel_dia == true
    let group = jobCardDetails?.group;
    getOrdersList(group?.orders?.map((order) => order.order_id)?.sort())
      .then((response) => {
        const request = response?.data
          ?.filter(order => order.cutter_reel_dia === true)
          .map(order => {
            //check if both max and min are same
            const isConstant = parseFloat(min_dia_cutter) === parseFloat(max_dia_cutter);
            return {
              order_id: JSON.stringify(order.id),
              planned_weight: order?.planned_weight,
              reel_od: isConstant ? [`${max_dia_cutter} ${reel_dia_unit_cutter}`] : {
                minimum_reel_od: parseFloat(min_dia_cutter),
                maximum_reel_od: parseFloat(max_dia_cutter),
              },
              group_id: group?.group_id,
              cutter_reel_dia: true,
              od_type: isConstant ? "constant" : "range",
              units: isConstant ? {
                planned_weight: order?.units?.planned_weight,
              } : {
                planned_weight: order?.units?.planned_weight,
                minimum_reel_od: reel_dia_unit_cutter,
                maximum_reel_od: reel_dia_unit_cutter
              }
            };
          });
        request.length && editQtyToBePlannedForReviewOrder(request, "new_solution")
          .then(response => {
            // console.log(response);
          })
          .catch(error => {
            console.error("Error in updating order:", error?.response?.data);
          })
          .finally(() => {
            setTabKey(key);
            setIsSheetReelChanged(!isSheetReelChanged);
            reelDiaUpdateInFlightRef.current = false;
          });
        if (!request.length) {
          setTabKey(key);
          reelDiaUpdateInFlightRef.current = false;
        }

      })
      .catch((error) => {
        console.log("error", error);
        reelDiaUpdateInFlightRef.current = false;
      })
  };

  /** Tab switch: may trigger cutter reel-diameter sync when opening cutter tab. */
  const handleTabChange = async (key) => {
    await setUpdatedFormValues();
    if (key == 3) {
      handleCutterReelDiaChange(key);
    }
    else setTabKey(key);

  };

  /** Form submit: clamps planned weights, then calls parent `onClickCreateSolution` if orders exist. */
  const onFinish = async (e) => {
    // let updatedFormValues = formValues;
    // if (tabKey == 1) {
    //   updatedFormValues['status'] = e.status;
    //   updatedFormValues['selectedSizes'] = [];
    //   let temp = stockSizes.filter(item => item.isSelected == true);
    //   temp.forEach(item => {
    //     var index = stockSizes.findIndex((obj) => obj.stockSize == item.stockSize);

    //     let selectedSizes = {
    //       stockSizeId: stockSizes[index].stockSizeId,
    //       stockSize: item.stockSize,
    //       allowedQuantity: e['allowed-quantity' + index],
    //       reels: e['reels' + index],
    //       plannedWeight: e['planned-weight' + index]
    //     }
    //     updatedFormValues.selectedSizes.push(selectedSizes);
    //   })
    //   setFormValues(updatedFormValues);
    // }
    // else {
    //   updatedFormValues['minDeckleLength'] = e.min_deckle_length;
    //   updatedFormValues['maxDeckleLength'] = e.max_deckle_length;
    //   updatedFormValues['deckleLengthUnit'] = e.deckleLengthUnit;
    //   updatedFormValues['minWidth'] = e.min_width;
    //   updatedFormValues['maxWidth'] = e.max_width;
    //   updatedFormValues['widthUnit'] = e.widthUnit;
    //   updatedFormValues['effectiveDeckleLength'] = e.effective_deckle_length;
    //   updatedFormValues['cutters'] = e.cutters;
    // }
    // setFormValues(updatedFormValues);

    // console.log(12344, e);

    setStockSizesArray(stockSizes);
    const newSelectedSizes = formValues.selectedSizes.map((value) => {
      if (
        parseFloat(value.plannedWeight) > parseFloat(value.allowedQuantity)
      ) {
        return {
          ...value,
          plannedWeight: value.allowedQuantity,
        };
      } else return value;
    });
    if (formValues.selectedSizes.length)
      formValues.selectedSizes = newSelectedSizes;
    if (orderIdList && orderIdList.length) onClickCreateSolution(formValues);
    else {
      setOrderToastr(true);
      setTimeout(() => {
        setOrderToastr(false);
      }, 3000);
    }
  };

  /** "All sizes" vs "selected sizes": selects stock rows and reapplies allowed quantities. */
  const handleRunTypeChange = (e) => {
    if (e.target.value == "allSizes") {
      let tempStockSizes = [...stockSizes];
      tempStockSizes.map((stockSize, index) => {
        let sizeDetails =
          createNewSolutionFormValuesForSizes?.selectedSizes.filter(
            (size) => size.stockSizeId == stockSize.stockSizeId
          );
        if (sizeDetails && sizeDetails.length > 0) {
          onAllowedQuantityChange(
            sizeDetails[0].length,
            sizeDetails[0].width,
            sizeDetails[0].allowedQuantity,
            index
          );
        } else {
          onAllowedQuantityChange(
            stockSize.length,
            stockSize.width,
            stockSize.availableLimit,
            index
          );
        }
        stockSize.isSelected = true;
      });
      // setStockSizes(stockSizes.map(stockSize => ({...stockSize, isSelected: true})))
      setStockSizes(tempStockSizes);
    } else {
      setStockSizes(
        stockSizes.map((stockSize) => ({ ...stockSize, isSelected: false }))
      );
    }
  };

  /** Toggles selection for a stock row; for sheets recalculates allowed quantity from limits. */
  const handleSwitchChange = (index) => {
    setSwitchTooltip(!switchTooltip);
    let temp = [...stockSizes];
    if (stockSizes[index].type === "sheet") {
      onAllowedQuantityChange(
        temp[index].length,
        temp[index].width,
        temp[index].availableLimit,
        index
      );
    }
    temp[index].isSelected = !stockSizes[index].isSelected;
    setStockSizes(temp);
  };

  /** Derives effective deckle length from max deckle and trims; sets validation error if negative. */
  const changeDeckleLength = () => {
    setDeckleUnit(formValuesForStock?.units?.effective_deckle_length);
    let result =
      form.getFieldValue("max_deckle_length") *
      CoversionFactorUnitsToCM[form.getFieldValue("deckleLengthUnit")] -
      form.getFieldValue("min_width") *
      CoversionFactorUnitsToCM[form.getFieldValue("widthUnit")] -
      form.getFieldValue("max_width") *
      CoversionFactorUnitsToCM[form.getFieldValue("widthUnit")];
    result = (
      result * CoversionFactorCMToUnits[formValuesForStock?.units?.effective_deckle_length]
    ).toFixed(3);
    // form.setFieldsValue({
    //   effective_deckle_length: (
    //     result *
    //     CoversionFactorCMToUnits[form.getFieldValue("deckleLengthUnit")]
    //   ).toFixed(3),
    // });

    if (result < 0) {
      form.setFieldsValue({
        // min_width: "",
        // max_width: "",
        // effective_deckle_length: "",
      });
      setShowError({
        error: true,
        message: `Effective deckle length cannot be negative`,
      });
    } else {
      setShowError({
        error: false,
      });
      form.setFieldsValue({
        effective_deckle_length: result,
      });
    }
  };

  /** Same as changeDeckleLength for the cutter machine fields. */
  const changeDeckleLengthCutter = () => {
    setDeckleUnitCutter(formValuesForStock?.units_cutter?.effective_deckle_length);
    let result =
      form.getFieldValue("max_deckle_length_cutter") *
      CoversionFactorUnitsToCM[
      form.getFieldValue("deckleLengthUnit_cutter")
      ] -
      form.getFieldValue("min_width_cutter") *
      CoversionFactorUnitsToCM[form.getFieldValue("widthUnit_cutter")] -
      form.getFieldValue("max_width_cutter") *
      CoversionFactorUnitsToCM[form.getFieldValue("widthUnit_cutter")];
    result = (
      result *
      CoversionFactorCMToUnits[formValuesForStock?.units_cutter?.effective_deckle_length]
    ).toFixed(3)
    // form.setFieldsValue({
    //   effective_deckle_length_cutter: (
    //     result *
    //     CoversionFactorCMToUnits[form.getFieldValue("deckleLengthUnit_cutter")]
    //   ).toFixed(3),
    // });

    if (result < 0) {
      // form.setFieldsValue({
      //   // min_width: "",
      //   // max_width: "",
      //   // effective_deckle_length: "",
      // });
      setShowCutterError({
        error: true,
        message: `Effective deckle length cannot be negative`,
      });
    } else {
      setShowCutterError({
        error: false,
      });
      form.setFieldsValue({ effective_deckle_length_cutter: result });
    }
  };

  // const onAllowedQuantityChange = (value, size, index) => {
  //   if (parseFloat(value) > parseFloat(stockSizes[index].availableLimit)) {
  //     let updatedStocks = stockSizes;
  //     stockSizes[index].allowedQuantityError =
  //       "Allowed Qty should be less than or equal to Available Limit";
  //     setStockSizes(updatedStocks);
  //   } else {
  //     let updatedStocks = stockSizes;
  //     stockSizes[index].allowedQuantityError = "";
  //     setStockSizes(updatedStocks);
  //   }
  //   calculatePlannedReels(
  //     size,
  //     +value,
  //     +productData.bulk,
  //     jobCardDetails.group.grouping_params.core_id,
  //     jobCardDetails.group.grouping_params.reel_od,
  //     index
  //   );
  //   calculatePlannedWeight(
  //     size,
  //     +productData.bulk,
  //     jobCardDetails.group.grouping_params.reel_od,
  //     jobCardDetails.group.grouping_params.core_id,
  //     index
  //   );
  // };

  // const calculatePlannedReels = (size, weight, bulk, coreOd, reelOd, index) => {
  //   const value =
  //     (parseFloat(
  //       weight * conversionFactorUnitsToTonne[stockSizes[index].units.quantity]
  //     ) *
  //       1000 *
  //       1000 *
  //       parseFloat(bulk) *
  //       4) /
  //     (3.14 *
  //       parseFloat(
  //         size * CoversionFactorUnitsToCM[stockSizes[index].units.width]
  //       ) *
  //       (Math.pow(
  //         parseFloat(
  //           reelOd *
  //             CoversionFactorUnitsToCM[
  //               jobCardDetails.group.grouping_params.units.reel_od
  //             ]
  //         ),
  //         2
  //       ) -
  //         Math.pow(
  //           parseFloat(
  //             coreOd *
  //               CoversionFactorUnitsToCM[
  //                 jobCardDetails.group.grouping_params.units.core_id
  //               ]
  //           ),
  //           2
  //         )));
  //   // if (validateData.quantity !== "reel") {
  //   setPlannedReels(value.toFixed(3));
  //   form.setFieldsValue({ [`reels${index}`]: Math.floor(value.toFixed(3)) });
  //   // } else form.setFieldsValue({ no_of_reel_sheet: "" });
  // };

  // const calculatePlannedWeight = (size, bulk, reelOd, coreOd, index) => {
  //   const value =
  //     (3.14 *
  //       parseFloat(
  //         size * CoversionFactorUnitsToCM[stockSizes[index].units.width]
  //       ) *
  //       (Math.pow(
  //         parseFloat(
  //           reelOd *
  //             CoversionFactorUnitsToCM[
  //               jobCardDetails.group.grouping_params.units.reel_od
  //             ]
  //         ),
  //         2
  //       ) -
  //         Math.pow(
  //           parseFloat(
  //             coreOd *
  //               CoversionFactorUnitsToCM[
  //                 jobCardDetails.group.grouping_params.units.core_id
  //               ]
  //           ),
  //           2
  //         )) *
  //       parseFloat(form.getFieldValue("reels" + index))) /
  //     (1000 * 1000 * parseFloat(bulk) * 4);
  //   form.setFieldsValue({
  //     [`planned-weight${index}`]: (
  //       value * conversionFactorTonneToUnits[stockSizes[index].units.quantity]
  //     ).toFixed(3),
  //   });
  //   if (
  //     parseFloat(stockSizes[index].availableLimit) <
  //       (
  //         value * conversionFactorTonneToUnits[stockSizes[index].units.quantity]
  //       ).toFixed(3) &&
  //     jobCardDetails?.group?.machines[0]?.machine_type !== "rewinder"
  //   ) {
  //     let updatedStocks = stockSizes;
  //     stockSizes[index].plannedWeightError =
  //       "Planned Weight should be less than or equal to Available Limit";
  //     setStockSizes(updatedStocks);
  //   } else {
  //     let updatedStocks = stockSizes;
  //     stockSizes[index].plannedWeightError = "";
  //     setStockSizes(updatedStocks);
  //   }
  //   setRerender(true);
  // };
  /** Toggles optimize-unique-partitions; delegates to parent. */
  const handleSwitchChange2 = (isChecked) => {
    // const isChecked = e.target.checked;
    onOptimizePartitionChange(isChecked);
    // location?.state?.optimize_unique_partitions = checked;
  };
  /** Toggles minimize-overfulfillment; delegates to parent. */
  const handleSwitchChange3 = (isChecked) => {
    // const isChecked = e.target.checked;
    onMinimizeOverfulfillmentChange(isChecked);
    // location?.state?.optimize_unique_partitions = checked;
  };

  /** Validates a subset of form fields (used from inline inputs). */
  const validateFieldsOnChange = (fields) => {
    form.validateFields(fields);
  };


  /**
   * Updates allowed-quantity validation for a row and recalculates planned sheets when inputs are valid.
   */
  const onAllowedQuantityChange = (length, width, weight, index) => {
    // Use a functional update to get the latest state
    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) => {
        if (i === index) {
          const newStock = { ...stock }; // Create a new object
          if (parseFloat(weight) > parseFloat(stock.availableLimit)) {
            newStock.allowedQuantityError =
              "Allowed Qty should be less than or equal to Available Limit";
          } else {
            newStock.allowedQuantityError = "";
          }
          return newStock;
        }
        return stock;
      })
    );

    // Check for form validation errors before calculating
    const errors = form.getFieldsError([
      `allowed-quantity${index}`,
      `length${index}`,
      `width${index}`,
    ]);
    const hasError = errors.some(field => field.errors.length > 0);

    if (!hasError && length && width && weight) {
      calculatePlannedSheets(length, width, weight, index);
    }
  };

  /** Derives sheet count from weight, GSM, and dimensions for sheet stock. */
  const calculatePlannedSheets = (length, width, weight, index) => {
    const stockItem = stockSizes[index];
    if (!stockItem) return; // Guard against race conditions

    const value =
      (parseFloat(weight * conversionFactorUnitsToTonne[stockItem.units.quantity]) * 10000 * 1000000) /
      (parseFloat(productData.gsm) *
        parseFloat(length * CoversionFactorUnitsToCM[stockItem.units.length]) *
        parseFloat(width * CoversionFactorUnitsToCM[stockItem.units.width]));

    const plannedSheetsValue = isNaN(value) ? 0 : Math.floor(value);

    form.setFieldsValue({ [`sheets${index}`]: plannedSheetsValue });

    // Use .map() for an immutable update
    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) =>
        i === index ? { ...stock, sheets: plannedSheetsValue } : stock
      )
    );

    //calculatePlannedWeight(length, width, plannedSheetsValue, index);
  };

  /** Derives planned weight from dimensions, sheet count, and GSM. */
  const calculatePlannedWeight = (length, width, sheets, index) => {
    const stockItem = stockSizes[index];
    if (!stockItem) return; // Guard clause

    const value =
      (parseFloat(length * CoversionFactorUnitsToCM[stockItem.units.length]) *
        parseFloat(width * CoversionFactorUnitsToCM[stockItem.units.width]) *
        parseFloat(sheets) *
        parseFloat(productData.gsm)) /
      (10000 * 1000000);

    const plannedWeightValue = isNaN(value) ? '' : toFixedValue(value * conversionFactorTonneToUnits[stockItem.units.quantity], 3);
    form.setFieldsValue({ [`planned-weight${index}`]: plannedWeightValue });

    // Use a functional update with .map()
    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) => {
        if (i === index) {
          const newStock = { ...stock };
          if (parseFloat(stock.availableLimit) < plannedWeightValue) {
            newStock.plannedWeightError =
              "Planned Weight should be less than or equal to Available Limit";
          } else {
            newStock.plannedWeightError = "";
          }
          return newStock;
        }
        return stock;
      })
    );
  };

  /** Enters/exits inline edit for a stock row; for sheets refreshes allowed quantity. */
  const handleEdit = (index) => {
    setSwitchTooltip(!switchTooltip);
    const stockToUpdate = stockSizes[index];

    if (stockSizes[index].type === "sheet")
      onAllowedQuantityChange(
        stockToUpdate.length,
        stockToUpdate.width,
        stockToUpdate.allowedQuantity,
        index,
      );

    // Use .map() to toggle the isEdit flag
    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) =>
        i === index ? { ...stock, isEdit: !stock.isEdit } : stock
      )
    );
  };

  /** Validates and saves inline edits for a stock row (duplicate size check, merge into state). */
  const onSaveChages = async (index) => {
    try {
      // 1. Update validation to check for length and width
      const fieldsToValidate = [

        `width${index}`,
        `allowed-quantity${index}`,
      ];
      if (stockSizes[index].type === "sheet") {
        fieldsToValidate.push(`grain${index}`, `length${index}`);
      }

      if (stockSizes[index].isRequired) {
        fieldsToValidate.push(`lower_limit${index}`, `upper_limit${index}`);
      }

      await form.validateFields(fieldsToValidate);

      // 2. Update duplicate check logic for length and width
      const currentLengthCM =
        parseFloat(form.getFieldValue(`length${index}`)) *
        CoversionFactorUnitsToCM[form.getFieldValue(`length_unit${index}`)];

      const currentWidthCM =
        parseFloat(form.getFieldValue(`width${index}`)) *
        CoversionFactorUnitsToCM[form.getFieldValue(`width_unit${index}`)];

      const isDuplicate = stockSizes.some((data, idx) => {
        if (idx === index) {
          // Skip self-comparison and existing (non-editable) stocks
          return false;
        }
        const existingLengthCM = parseFloat(data.length) * CoversionFactorUnitsToCM[data.units.length];
        const existingWidthCM = parseFloat(data.width) * CoversionFactorUnitsToCM[data.units.width];

        // Check for both (L x W)duplicates
        if (stockSizes[index].type === "sheet" && stockSizes[idx].type === "sheet") {
          return (existingLengthCM === currentLengthCM && existingWidthCM === currentWidthCM);
        } else {
          if (stockSizes[index].type === "reel" && stockSizes[idx].type === "reel")
            return (existingWidthCM === currentWidthCM);
        }
      });

      if (isDuplicate) {
        setSizeErrorToastr(true);
        setTimeout(() => {
          setSizeErrorToastr(false);
        }, 3000);
        return; // Prevent saving if a duplicate is found
      }

      // Use .map() to update the state with all the new values
      setStockSizes((prevStocks) =>
        prevStocks.map((stock, i) => {
          if (i === index) {
            // Create a new object with all the updated fields
            return {
              ...stock,
              allowedQuantity: form.getFieldValue(`allowed-quantity${index}`),
              stockSize: stockSizes[index].type == 'sheet' ? form.getFieldValue(`width${index}`) + ' ' + lengthUnit[form.getFieldValue(`width_unit${index}`)].displayName.toUpperCase() + " * " + form.getFieldValue(`length${index}`) + ' ' + lengthUnit[form.getFieldValue(`length_unit${index}`)].displayName.toUpperCase() : form.getFieldValue(`width${index}`) + ' ' + lengthUnit[form.getFieldValue(`width_unit${index}`)].displayName.toUpperCase(),
              length: form.getFieldValue(`length${index}`),
              width: form.getFieldValue(`width${index}`),
              grain: form.getFieldValue(`grain${index}`),
              weight_lb: form.getFieldValue(`lower_limit${index}`),
              weight_ub: form.getFieldValue(`upper_limit${index}`),
              units: {
                ...stock.units,
                quantity: form.getFieldValue(`allowed-quantity_unit${index}`),
                length: form.getFieldValue(`length_unit${index}`),
                width: form.getFieldValue(`width_unit${index}`),
                weight_lb: form.getFieldValue(`lower_unit${index}`),
                weight_ub: form.getFieldValue(`upper_unit${index}`),
              },
              isEdit: false, // Flip the edit flag
            };
          }
          return stock;
        })
      );
    } catch (err) {
      // ... (error handling is fine)
    }
  };

  /** Removes a new/required row or reverts inline edits and restores form fields. */
  const onDiscardChanges = (index) => {
    let updatedStocks = [...stockSizes];

    // CASE 1: Remove if it's new or required
    if (stockSizes[index].isNew || stockSizes[index].isRequired) {
      updatedStocks.splice(index, 1);

      const total = updatedStocks.length + 1;
      for (let i = index; i < total; i++) {
        const next = i + 1;
        const keys = [
          "size",
          "length",
          "width",
          "length_unit",
          "width_unit",
          "grain",
          "allowed-quantity",
          "size_unit",
          "allowed-quantity_unit",
          "lower_limit",
          "lower_unit",
          "upper_limit",
          "upper_unit",
        ];

        keys.forEach((key) => {
          const nextKey = `${key}${next}`;
          const currKey = `${key}${i}`;
          const nextValue = form.getFieldValue(nextKey);
          form.setFieldsValue({ [currKey]: nextValue ?? undefined });
        });
      }

      // Clear the last form group fields
      const lastIndex = updatedStocks.length;
      [
        "size",
        "length",
        "width",
        "length_unit",
        "width_unit",
        "grain",
        "allowed-quantity",
        "size_unit",
        "allowed-quantity_unit",
        "lower_limit",
        "lower_unit",
        "upper_limit",
        "upper_unit",
      ].forEach((key) => {
        form.setFieldsValue({ [`${key}${lastIndex}`]: undefined });
      });

      setStockSizes(updatedStocks);
    }

    // CASE 2: Just discard edits
    else {
      updatedStocks[index].isEdit = false;
      const stock = updatedStocks[index];

      const fieldMap = {
        [`size${index}`]: stock.stockSize,
        [`length${index}`]: stock.length,
        [`width${index}`]: stock.width,
        [`length_unit${index}`]: stock.units.length,
        [`width_unit${index}`]: stock.units.width,
        [`grain${index}`]: stock.grain,
        [`allowed-quantity${index}`]: stock.allowedQuantity,
        [`size_unit${index}`]: stock.units.width,
        [`allowed-quantity_unit${index}`]: stock.units.quantity,
      };

      if (stock.isRequired) {
        fieldMap[`lower_limit${index}`] = stock.weight_lb;
        fieldMap[`lower_unit${index}`] = stock.units.weight_lb;
        fieldMap[`upper_limit${index}`] = stock.weight_ub;
        fieldMap[`upper_unit${index}`] = stock.units.weight_ub;
      }

      form.setFieldsValue(fieldMap);
      setStockSizes(updatedStocks);
    }
  };






  /** Appends an editable blank stock row (reel or sheet). */
  const onAddStock = (type) => {
    let updatedStocks = [...stockSizes];
    let stock = {
      grain: undefined,
      allowedQuantity: "",
      stockSize: "",
      length: "",
      width: "",
      stockSizeId: null,
      isSelected: true,
      isNew: true,
      isEdit: true,
      units: {
        quantity: unitData.units_management.weight.default,
        width: unitData.units_management.length.default,
        length: unitData.units_management.length.default,
      },
      isGrainChanged: false,
      rotate: false,
      type: type,
    };
    updatedStocks.push(stock);

    setStockSizes([...updatedStocks]);
  };

  /** Appends a required-stock row with weight bounds fields. */
  const onAddRequiredStock = (type) => {
    let updatedStocks = [...stockSizes];
    let stock = {
      grain: undefined,
      allowedQuantity: "",
      stockSize: "",
      isSelected: true,
      isRequired: true,
      isEdit: true,
      length: "",
      width: "",
      stockSizeId: null,
      weight_lb: '',
      weight_ub: '',
      priority_stock: false,
      units: {
        quantity: unitData.units_management.weight.default,
        width: unitData.units_management.length.default,
        length: unitData.units_management.length.default,
        weight_lb: unitData.units_management.weight.default,
        weight_ub: unitData.units_management.weight.default,
      },
      isGrainChanged: false,
      rotate: false,
      type: type,
    };
    updatedStocks.push(stock);

    setStockSizes([...updatedStocks]);
  };

  /** Toggles priority stock flag for a row. */
  const changePriority = (e, index) => {
    const { checked } = e.target;

    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) =>
        i === index ? { ...stock, priority_stock: checked } : stock
      )
    );
  };



  /** Toggles grain rotation flag for a sheet row. */
  const changeGrain = (e, index) => {
    const { checked } = e.target;

    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) =>
        i === index ? { ...stock, isGrainChanged: checked } : stock
      )
    );
  };


  /** Derives upper sheet bound from upper weight limit for required sheet stock. */
  const calculateUpperLimitSheets = (length, width, upperWeight, index) => {
    // Proceed only if essential values are present and valid
    const errors = form.getFieldsError([
      `length${index}`,
      `width${index}`,
      `upper_limit${index}`,
    ]);

    const hasError = errors.some(field => field.errors.length > 0);

    if (
      !upperWeight ||
      !length ||
      !width ||
      !productData.gsm ||
      !stockSizes[index] ||
      hasError
    ) {
      // Clear the value if inputs are invalid
      setStockSizes((prevStocks) => {
        const newStocks = [...prevStocks];
        if (newStocks[index]) {
          newStocks[index].upperSheets = 0;
        }
        return newStocks;
      });
      return;
    }


    // Get the units for calculation from the form and state
    const upperWeightUnit = form.getFieldValue(`upper_unit${index}`);
    const lengthUnit = form.getFieldValue(`length_unit${index}`);
    const widthUnit = form.getFieldValue(`width_unit${index}`);

    // Calculate the number of sheets
    const sheetCount =
      (parseFloat(upperWeight * conversionFactorUnitsToTonne[upperWeightUnit]) * 10000 * 1000000) /
      (parseFloat(productData.gsm) *
        parseFloat(length * CoversionFactorUnitsToCM[lengthUnit]) *
        parseFloat(width * CoversionFactorUnitsToCM[widthUnit]));

    const calculatedSheets = isNaN(sheetCount) ? 0 : Math.floor(sheetCount);

    // Update the stockSizes array with the new 'upperSheets' value
    setStockSizes((prevStocks) => {
      const newStocks = [...prevStocks];
      newStocks[index] = {
        ...newStocks[index],
        upperSheets: calculatedSheets,
      };
      return newStocks;
    });
  };

  /** Derives lower sheet bound from lower weight limit for required sheet stock. */
  const calculateLowerLimitSheets = (length, width, lowerWeight, index) => {
    // Proceed only if essential values are present and valid
    const errors = form.getFieldsError([
      `length${index}`,
      `width${index}`,
      `lower_limit${index}`,
    ]);

    const hasError = errors.some(field => field.errors.length > 0);

    if (
      !lowerWeight ||
      !length ||
      !width ||
      !productData.gsm ||
      !stockSizes[index] ||
      hasError
    ) {
      // Clear the value if inputs are invalid
      setStockSizes((prevStocks) => {
        const newStocks = [...prevStocks];
        if (newStocks[index]) {
          newStocks[index].lowerSheets = 0;
        }
        return newStocks;
      });
      return;
    }

    // Get the units for calculation from the form and state
    const lowerWeightUnit = form.getFieldValue(`lower_unit${index}`);
    const lengthUnit = form.getFieldValue(`length_unit${index}`);
    const widthUnit = form.getFieldValue(`width_unit${index}`);
    // Calculate the number of sheets
    const sheetCount =
      (parseFloat(lowerWeight * conversionFactorUnitsToTonne[lowerWeightUnit]) * 10000 * 1000000) /
      (parseFloat(productData.gsm) *
        parseFloat(length * CoversionFactorUnitsToCM[lengthUnit]) *
        parseFloat(width * CoversionFactorUnitsToCM[widthUnit]));

    const calculatedSheets = isNaN(sheetCount) ? 0 : Math.floor(sheetCount);

    // Update the stockSizes array with the new 'lowerSheets' value
    setStockSizes((prevStocks) => {
      const newStocks = [...prevStocks];
      newStocks[index] = {
        ...newStocks[index],
        lowerSheets: calculatedSheets,
      };
      return newStocks;
    });
  };

  /** Opens tolerance modal when orders exist; otherwise shows a short toast. */
  const onClickSetToleranceButton = () => {
    if (orderIdList.length != 0)
      setToleranceModal(!toleranceModal);
    else {
      setOrderToastr(true);
      setTimeout(() => setOrderToastr(false), 2300);
    }
  };


  // return unitData && deckleUnit ? (
  return (
    <RightLayoutContainer id="right-layout-container">
      <PageTitleComp className="marginRightAdg" style={{ borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          onBack={() => backButtonClicked()}
          title={
            solutionType == "replan" ? "Replan Job Card" : "Create new solution"
          }
          extra={[
            <div
              style={{
                display: "flex",
                alignItems: "start",
                justifyContent: "center",
              }}
            >
              {tabKey === "3" && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={onClickSetToleranceButton}
                    >
                      <Iconmoon icon="set" size={15} color="#EA655B" />
                      Set Tolerance
                    </Button>
                    {showAlert.isGlobalToleranceChanged && <span
                      className="failedJobMessage"
                      style={{
                        marginTop: "0px"
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        {showAlert.isGlobalToleranceChanged &&
                          (showAlert.isToleranceChanged ||
                            showAlert.isOrderChanged) && showAlert.toleranceLevel === "JobCard" && (
                            <Tooltip
                              placement="bottomRight"
                              title={
                                "Tolerance applied earlier do not apply to the newly selected/edited orders. Click 'Set Tolerance' again to update."
                              }
                            >
                              <Iconmoon
                                icon="warning-icon"
                                size={14}
                                color="#EA655B"
                              />
                            </Tooltip>
                          )}
                        {globalTolerance.lower !== 0 && globalTolerance.upper !== 0 && showAlert.toleranceLevel === "JobCard" && <div>
                          LB <strong>{globalTolerance.lower}%</strong>
                          {"    "}
                          <span style={{ paddingLeft: "5px" }} />
                          UB <strong>{globalTolerance.upper}%</strong>
                        </div>}
                      </div>
                    </span>}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      key="2"
                      className="themeBtn noBg"
                      onClick={() => {
                        if (orderIdList.length != 0)
                          setJobCardReelODEditModal(true)
                        else {
                          setOrderToastr(true);
                          setTimeout(() => setOrderToastr(false), 2000);
                        }
                      }
                      }
                    >
                      <Iconmoon icon="set" size={15} color="#EA4E2C" />
                      Set Reel OD
                    </Button>
                    {globalReelOD.level == "JobCard" &&
                      <span className="failedJobMessage" style={{ marginTop: "0px", display: "flex", alignItems: "center", gap: "3px" }}>
                        {showAlert.isGlobalReelODChanged &&
                          (showAlert.isReelODChanged ||
                            showAlert.isReelOrderChanged) &&
                          <Tooltip
                            placement="bottomRight"
                            title={
                              "Reel dimensions applied earlier do not apply to the newly selected/edited orders. Click 'Set Reel OD' again to update."
                            }
                          >
                            <Iconmoon
                              icon="warning-icon"
                              size={14}
                              color="#EA655B"
                            />
                          </Tooltip>
                        }
                        {globalReelOD.type == "Constant"
                          ? <span>
                            {globalReelOD.selectedReelOD[0]}
                            {globalReelOD.selectedReelOD.length > 1 &&
                              <Tooltip
                                placement="bottomRight"
                                title={
                                  () => {
                                    let text = "";
                                    globalReelOD.selectedReelOD.slice(1).forEach(item => text = text + " " + item);
                                    return text;
                                  }
                                }
                              >
                                <span>{`  & ${globalReelOD.selectedReelOD.length - 1}more`}</span>
                              </Tooltip>
                            }
                          </span>
                          : <span>{`${globalReelOD.min_reel_od} ${globalReelOD.unit} - ${globalReelOD.max_reel_od} ${globalReelOD.unit}`}</span>}
                      </span>
                    }
                  </div>
                </>
              )}
              <Button
                key="3"
                className="themeBtn"
                onClick={onClickCreateSolutionButton}
              >
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Create Solution
              </Button>
            </div>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <Form
        form={form}
        name="basic"
        autoComplete="off"
        className="haberLogin"
        onFinish={onFinish}
        onFinishFailed={(error) => {
          console.log("Form Error", error);
        }}
        initialValues={{
          remember: true,
        }}
      >
        <div className="groupedTabed">
          <StyledTab>
            <Tabs
              defaultActiveKey="1"
              onChange={handleTabChange}
              style={{ padding: "0px 0px 20px 0px" }}
            >
              <Panes tab="Stock Size" key="1">
                <DetailFields>
                  <HaberForm>
                    <>
                      <div className="groupDetailWrap">
                        <Row gutter={[16, 16]} className="groupForm">
                          <Col span={14}>
                            <div
                              className="boxFieldTitle"
                              style={{ marginTop: "20px" }}
                            >
                              <label>Select Run Type</label>
                              <p>
                                Select if you would like to include specific sizes
                                quantity or let the system decide the optimum size
                                and quantity
                              </p>
                            </div>
                          </Col>
                          <Col span={10}>
                            <div
                              className="boxFormType switchRadio extraWidth"
                              style={{
                                justifyContent: "flex-end",
                                display: "flex",
                                marginTop: "20px",
                              }}
                            >
                              <Form.Item
                                name="status"
                                className=""
                                initialValue={
                                  createNewSolutionFormValuesForSizes?.status
                                    ? createNewSolutionFormValuesForSizes?.status
                                    : "selectedSizes"
                                }
                              >
                                <Radio.Group
                                  options={runTypes}
                                  onChange={handleRunTypeChange}
                                  optionType="button"
                                  buttonStyle="solid"
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>

                        <Row gutter={[16, 16]} className="groupForm">
                          <Col span={24} className="blockBreak centerAlign">
                            <PaperBlockList>
                              <Row style={{ width: "100%" }}>
                                <Col span={10}>
                                  <div
                                    className="boxFieldTitle removeStar"
                                    style={{ marginTop: "20px" }}
                                  >
                                    <label>Select Stock Sizes</label>
                                    <p>
                                      Select the sizes and quantity to process
                                      with orders
                                    </p>
                                  </div>
                                </Col>
                                <Col span={14}>
                                  <>
                                    {stockSizes.map((stockSize, index) => {
                                      const isExistingStock = !stockSize.isNew && !stockSize.isRequired;
                                      const isNewStock = stockSize.isNew;
                                      const isRequiredStock = stockSize.isRequired;

                                      return stockSize.type === 'sheet' ? (
                                        <Row className="centerAlign" key={index}>
                                          <Row style={{ width: "100%" }}>
                                            <Col span={18}>
                                              <div className=" removeStar">
                                                <label>
                                                  {stockSize.stockSize ? (
                                                    <>
                                                      {stockSize.stockSize}
                                                      {stockSize.grain && (
                                                        <span
                                                          style={{
                                                            fontSize: "11px",
                                                            fontFamily: "var(--sf-pro-display-m)",
                                                            color: stockSize.grain === "long" ? "green" : "red",
                                                            lineHeight: "16px",
                                                            backgroundColor:
                                                              stockSize.grain === "long" ? "#e6f4ea" : "#fdecea",
                                                            borderRadius: "10px",
                                                            padding: "1px 8px",
                                                            marginLeft: "10px",
                                                            fontStyle: "unset",
                                                          }}
                                                        >
                                                          {stockSize.grain === 'long' ? 'LONG' : 'SHORT'}
                                                        </span>
                                                      )}
                                                    </>
                                                  ) : isRequiredStock ? "New Required Sheet Stock" : "New Sheet Stock"}
                                                </label>
                                                {!stockSize.isEdit && (
                                                  <p>
                                                    {isExistingStock && (
                                                      <span
                                                        style={{
                                                          width: "180px",
                                                          display: "inline-block",
                                                        }}
                                                      >
                                                        Available Limit :{" "}
                                                        {stockSize.availableLimit +
                                                          " " +
                                                          capitalize(
                                                            weightUnit[
                                                              stockSize?.availableUnit
                                                            ]?.displayName
                                                          ) +
                                                          (stockSize.availableDefaultLimit
                                                            ? " ( " +
                                                            stockSize.availableDefaultLimit +
                                                            " )"
                                                            : "")}
                                                      </span>
                                                    )}
                                                    <span>
                                                      Allowed Limit :{" "}
                                                      {stockSize.allowedQuantity +
                                                        " " +
                                                        capitalize(
                                                          weightUnit[
                                                            stockSize.units
                                                              .quantity
                                                          ].displayName
                                                        )}
                                                    </span>
                                                  </p>
                                                )}
                                              </div>
                                            </Col>
                                            <Col span={6}>
                                              <div className="actionBtn">
                                                {!stockSize.isEdit && (
                                                  <GlobalSet
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "flex-end",
                                                    }}
                                                  >
                                                    <Styled>
                                                      <Tooltip
                                                        placement="bottomRight"
                                                        title={"Edit Stock"}
                                                        getPopupContainer={(
                                                          triggerNode
                                                        ) => triggerNode}
                                                      >
                                                        <Button
                                                          className="textTypeBtn "
                                                          onClick={() =>
                                                            handleEdit(index)
                                                          }
                                                          style={{ right: "8" }}
                                                        >
                                                          <Iconmoon
                                                            icon="edit"
                                                            size={16}
                                                            color="#A19F9D"
                                                          />
                                                        </Button>
                                                      </Tooltip>
                                                    </Styled>
                                                    <Styled>
                                                      <Tooltip
                                                        placement="bottomRight"
                                                        title={
                                                          stockSize.isSelected
                                                            ? "Remove Stock"
                                                            : "Add Stock"
                                                        }
                                                        getPopupContainer={(
                                                          triggerNode
                                                        ) => triggerNode}
                                                      >
                                                        <Switch
                                                          checked={
                                                            stockSize.isSelected
                                                          }
                                                          onChange={() =>
                                                            handleSwitchChange(
                                                              index
                                                            )
                                                          }
                                                          className="switch-new"
                                                          disabled={false}
                                                        />
                                                      </Tooltip>
                                                    </Styled>
                                                  </GlobalSet>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>

                                          {stockSize.isEdit && (
                                            <>
                                              <Row
                                                style={{ width: "100%", marginBottom: '10px' }}
                                                className=" "
                                              >
                                                {isExistingStock ? (
                                                  <>
                                                    <Col
                                                      style={{ paddingRight: "5px" }}
                                                      span={10}
                                                    >
                                                      <div
                                                        className="boxFormType"
                                                        style={{ marginBottom: "0" }}
                                                      >
                                                        <Form.Item
                                                          label={"Length"}
                                                          className="dBlock"
                                                          style={{ marginBottom: 0 }}
                                                        >
                                                          <Input.Group compact>
                                                            <Form.Item
                                                              name={`length${index}`}
                                                              noStyle
                                                              rules={[
                                                                {
                                                                  required: true,
                                                                  message:
                                                                    "This field is required",
                                                                },
                                                                {
                                                                  pattern: new RegExp(
                                                                    /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                                  ),
                                                                  message:
                                                                    "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                                },
                                                              ]}
                                                              initialValue={
                                                                stockSize.length
                                                              }
                                                            >
                                                              <Input
                                                                placeholder="Length"
                                                                style={{
                                                                  width:
                                                                    "calc(100% - 70px)",
                                                                  borderTopRightRadius: 0,
                                                                  borderBottomRightRadius: 0,
                                                                  cursor: "not-allowed",
                                                                }}
                                                                readOnly

                                                              />
                                                            </Form.Item>
                                                            <Form.Item
                                                              name={`length_unit${index}`}
                                                              noStyle
                                                              initialValue={
                                                                stockSize.units.length
                                                              }
                                                            >
                                                              <Select
                                                                style={{
                                                                  width: 70,
                                                                  borderTopLeftRadius: 0,
                                                                  borderBottomLeftRadius: 0,
                                                                  cursor: "not-allowed",

                                                                }}
                                                                dropdownStyle={{
                                                                  minWidth: 70,
                                                                }}
                                                                suffixIcon={
                                                                  null
                                                                }
                                                                readOnly
                                                                open={false}
                                                              >
                                                                {unitData.units_management.length.data.map(
                                                                  (length) => (
                                                                    <Option
                                                                      key={length}
                                                                    >
                                                                      {
                                                                        lengthUnit[
                                                                          length
                                                                        ].displayName
                                                                      }
                                                                    </Option>
                                                                  )
                                                                )}
                                                              </Select>
                                                            </Form.Item>
                                                          </Input.Group>
                                                        </Form.Item>
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      style={{ paddingRight: "5px" }}
                                                      span={10}
                                                    >
                                                      <div
                                                        className="boxFormType"
                                                        style={{ marginBottom: "0" }}
                                                      >
                                                        <Form.Item
                                                          label={"Width"}
                                                          className="dBlock"
                                                          style={{ marginBottom: 0 }}

                                                        >
                                                          <Input.Group compact>
                                                            <Form.Item
                                                              name={`width${index}`}
                                                              noStyle
                                                              rules={[
                                                                {
                                                                  required: true,
                                                                  message:
                                                                    "This field is required",
                                                                },
                                                                {
                                                                  pattern: new RegExp(
                                                                    /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                                  ),
                                                                  message:
                                                                    "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                                },
                                                              ]}
                                                              initialValue={
                                                                stockSize.width
                                                              }
                                                            >
                                                              <Input
                                                                placeholder="Width"
                                                                style={{
                                                                  width:
                                                                    "calc(100% - 70px)",
                                                                  borderTopRightRadius: 0,
                                                                  borderBottomRightRadius: 0,
                                                                  cursor: "not-allowed",

                                                                }}
                                                                readOnly
                                                                drop
                                                              // onChange={(e) =>
                                                              //     onAllowedQuantityChange(
                                                              //       e.target.value,
                                                              //       stockSize.size,
                                                              //       index
                                                              //     )
                                                              //   }
                                                              />
                                                            </Form.Item>
                                                            <Form.Item
                                                              name={`width_unit${index}`}
                                                              noStyle
                                                              initialValue={
                                                                stockSize.units.width
                                                              }
                                                            >
                                                              <Select
                                                                style={{
                                                                  width: 70,

                                                                  borderTopLeftRadius: 0,
                                                                  borderBottomLeftRadius: 0,
                                                                  cursor: "not-allowed",
                                                                }}
                                                                dropdownRender={null}
                                                                readOnly
                                                                dropdownStyle={{
                                                                  minWidth: 70,
                                                                }}
                                                                suffixIcon={
                                                                  null
                                                                }
                                                                open={false}
                                                              // onChange={() => {
                                                              //   form.validateFields([`allowed-quantity${index}`]);
                                                              // }}
                                                              >
                                                                {unitData.units_management.length.data.map(
                                                                  (length) => (
                                                                    <Option
                                                                      key={length}
                                                                    >
                                                                      {
                                                                        lengthUnit[
                                                                          length
                                                                        ].displayName
                                                                      }
                                                                    </Option>
                                                                  )
                                                                )}
                                                              </Select>
                                                            </Form.Item>
                                                          </Input.Group>
                                                        </Form.Item>
                                                      </div>
                                                    </Col>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Col
                                                      style={{ paddingRight: "5px" }}
                                                      span={10}
                                                    >
                                                      <div
                                                        className="boxFormType"
                                                        style={{ marginBottom: "0" }}
                                                      >
                                                        <Form.Item
                                                          label={"Length"}
                                                          className="dBlock"
                                                          style={{ marginBottom: 0 }}
                                                        >
                                                          <Input.Group compact>
                                                            <Form.Item
                                                              name={`length${index}`}
                                                              noStyle
                                                              rules={[
                                                                { required: true, message: "This field is required" },
                                                                { pattern: new RegExp(/^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/), message: "Only Numeric characters greater than zero are allowed upto 3 decimal point" },
                                                              ]}
                                                              initialValue={stockSize.length}
                                                            >
                                                              <Input
                                                                placeholder="Length"
                                                                style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                                onChange={() => {
                                                                  const length = form.getFieldValue(`length${index}`);
                                                                  const width = form.getFieldValue(`width${index}`);
                                                                  const allowedQuantity = form.getFieldValue(`allowed-quantity${index}`);
                                                                  onAllowedQuantityChange(length, width, allowedQuantity, index);
                                                                  if (isRequiredStock) {
                                                                    const lowerLimit = form.getFieldValue(`lower_limit${index}`);
                                                                    const upperLimit = form.getFieldValue(`upper_limit${index}`);
                                                                    calculateLowerLimitSheets(length, width, lowerLimit, index);
                                                                    calculateUpperLimitSheets(length, width, upperLimit, index);
                                                                  }
                                                                }}
                                                              />
                                                            </Form.Item>
                                                            <Form.Item name={`length_unit${index}`} noStyle initialValue={stockSize.units.length}>
                                                              <Select
                                                                style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                                dropdownStyle={{ minWidth: 70 }}
                                                                suffixIcon={<DownArrowDraw />}
                                                                onChange={() => {
                                                                  const length = form.getFieldValue(`length${index}`);
                                                                  const width = form.getFieldValue(`width${index}`);
                                                                  const allowedQuantity = form.getFieldValue(`allowed-quantity${index}`);
                                                                  onAllowedQuantityChange(length, width, allowedQuantity, index);
                                                                  if (isRequiredStock) {
                                                                    const lowerLimit = form.getFieldValue(`lower_limit${index}`);
                                                                    const upperLimit = form.getFieldValue(`upper_limit${index}`);
                                                                    calculateLowerLimitSheets(length, width, lowerLimit, index);
                                                                    calculateUpperLimitSheets(length, width, upperLimit, index);
                                                                  }
                                                                }}
                                                              >
                                                                {unitData.units_management.length.data.map((length) => (<Option key={length}>{lengthUnit[length].displayName}</Option>))}
                                                              </Select>
                                                            </Form.Item>
                                                          </Input.Group>
                                                        </Form.Item>
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      style={{ paddingRight: "5px" }}
                                                      span={10}
                                                    >
                                                      <div
                                                        className="boxFormType"
                                                        style={{ marginBottom: "0" }}
                                                      >
                                                        <Form.Item
                                                          label={"Width"}
                                                          className="dBlock"
                                                          style={{ marginBottom: 0 }}
                                                        >
                                                          <Input.Group compact>
                                                            <Form.Item
                                                              name={`width${index}`}
                                                              noStyle
                                                              rules={[
                                                                { required: true, message: "This field is required" },
                                                                { pattern: new RegExp(/^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/), message: "Only Numeric characters greater than zero are allowed upto 3 decimal point" },
                                                              ]}
                                                              initialValue={stockSize.width}
                                                            >
                                                              <Input
                                                                placeholder="Width"
                                                                style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                                onChange={() => {
                                                                  const length = form.getFieldValue(`length${index}`);
                                                                  const width = form.getFieldValue(`width${index}`);
                                                                  const allowedQuantity = form.getFieldValue(`allowed-quantity${index}`);
                                                                  onAllowedQuantityChange(length, width, allowedQuantity, index);
                                                                  if (isRequiredStock) {
                                                                    const lowerLimit = form.getFieldValue(`lower_limit${index}`);
                                                                    const upperLimit = form.getFieldValue(`upper_limit${index}`);
                                                                    calculateLowerLimitSheets(length, width, lowerLimit, index);
                                                                    calculateUpperLimitSheets(length, width, upperLimit, index);
                                                                  }
                                                                }}
                                                              />
                                                            </Form.Item>
                                                            <Form.Item name={`width_unit${index}`} noStyle initialValue={stockSize.units.width}>
                                                              <Select
                                                                style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                                dropdownStyle={{ minWidth: 70 }}
                                                                suffixIcon={<DownArrowDraw />}
                                                                onChange={() => {
                                                                  const length = form.getFieldValue(`length${index}`);
                                                                  const width = form.getFieldValue(`width${index}`);
                                                                  const allowedQuantity = form.getFieldValue(`allowed-quantity${index}`);
                                                                  onAllowedQuantityChange(length, width, allowedQuantity, index);
                                                                  if (isRequiredStock) {
                                                                    const lowerLimit = form.getFieldValue(`lower_limit${index}`);
                                                                    const upperLimit = form.getFieldValue(`upper_limit${index}`);
                                                                    calculateLowerLimitSheets(length, width, lowerLimit, index);
                                                                    calculateUpperLimitSheets(length, width, upperLimit, index);
                                                                  }
                                                                }}
                                                              >
                                                                {unitData.units_management.length.data.map((length) => (<Option key={length}>{lengthUnit[length].displayName}</Option>))}
                                                              </Select>
                                                            </Form.Item>
                                                          </Input.Group>
                                                        </Form.Item>
                                                      </div>
                                                    </Col>
                                                  </>
                                                )}
                                                <Col span={4}>
                                                  <div
                                                    className="boxFormType"
                                                    style={{
                                                      marginBottom: "0",
                                                      marginTop: "33px",
                                                      display: "flex",
                                                      justifyContent: "flex-end",
                                                    }}
                                                  >
                                                    <Tooltip
                                                      title={
                                                        "Save the entered value"
                                                      }
                                                    >
                                                      <Button
                                                        key="1"
                                                        className="edit-btn"
                                                        style={{
                                                          padding: "0px",
                                                          margin: "0px",
                                                          width: "28px",
                                                          border: "none",
                                                          display: "inline-block",
                                                          marginRight: "10px",
                                                        }}
                                                        onClick={() =>
                                                          onSaveChages(index)
                                                        }
                                                      >
                                                        <Iconmoon
                                                          icon="check"
                                                          size={18}
                                                          color="#3FBD61"
                                                        />
                                                      </Button>
                                                    </Tooltip>

                                                    <Tooltip
                                                      title={"Delete the stock"}
                                                    >
                                                      <Button
                                                        key="2"
                                                        className="edit-btn"
                                                        style={{
                                                          padding: "0px",
                                                          margin: "0px",
                                                          width: "28px",
                                                          border: "none",
                                                          display: "inline-block",
                                                        }}
                                                        onClick={() =>
                                                          onDiscardChanges(index)
                                                        }
                                                      >
                                                        <Iconmoon
                                                          icon="cancel"
                                                          size={18}
                                                          color="red"
                                                        />
                                                      </Button>
                                                    </Tooltip>
                                                  </div>
                                                </Col>
                                              </Row>
                                              <Row
                                                style={{ width: "100%" }}
                                                className=" "
                                              >
                                                <Col
                                                  style={{ paddingRight: "5px" }}
                                                  span={10}
                                                >
                                                  <div
                                                    className="boxFormType"
                                                    style={{ marginBottom: "0" }}
                                                  >
                                                    <Form.Item
                                                      label={"Grain"}
                                                      className="dBlock"
                                                      name={`grain${index}`}
                                                      rules={[
                                                        { required: true, message: "This field is required" },
                                                      ]}
                                                      style={{ marginBottom: 4 }}
                                                      initialValue={
                                                        stockSize.grain
                                                      }                                                                    >
                                                      <Select
                                                        placeholder={"Select grain"}
                                                        suffixIcon={<DownArrowDraw />}
                                                      >
                                                        {grainTypeData.map((grainType) => (
                                                          <Option key={grainType.value}>{grainType.label}</Option>
                                                        ))}
                                                      </Select>
                                                    </Form.Item>
                                                  </div>
                                                </Col>
                                                <Col
                                                  style={{ paddingRight: "5px" }}
                                                  span={10}
                                                >
                                                  <div
                                                    className="boxFormType"
                                                    style={{ marginBottom: "0" }}
                                                  >
                                                    <Form.Item
                                                      label={"Allowed Limit"}
                                                      className="dBlock"
                                                      style={{ marginBottom: 0 }}
                                                      extra={
                                                        isExistingStock && (
                                                          <span
                                                            style={{
                                                              color:
                                                                "var(--para-text)",
                                                              fontSize: "12px",
                                                              fontFamily:
                                                                "var(--sf-pro-text) !important",
                                                            }}
                                                          >
                                                            Available Limit:{" "}
                                                            {stockSize.availableLimit}{" "}
                                                            {weightUnit[
                                                              stockSize.availableUnit
                                                            ]?.displayName?.toUpperCase()}
                                                          </span>
                                                        )
                                                      }
                                                    >
                                                      <Input.Group compact>
                                                        <Form.Item
                                                          name={`allowed-quantity${index}`}
                                                          noStyle
                                                          rules={[
                                                            { required: true, message: "This field is required" },
                                                            { pattern: new RegExp(/^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/), message: "Only Numeric characters greater than zero are allowed upto 3 decimal point" },
                                                            ...(isExistingStock ? [{
                                                              validator: (_, value) => {
                                                                if (conversionFactorUnitsToTonne[stockSize.units.quantity] * parseFloat(stockSize.availableLimit) < conversionFactorUnitsToTonne[form.getFieldValue(`allowed-quantity_unit${index}`)] * parseFloat(value)) {
                                                                  return Promise.reject("Allowed Qty should be less than or equal to Available Limit");
                                                                } else {
                                                                  return Promise.resolve();
                                                                }
                                                              },
                                                            }] : [])
                                                          ]}
                                                          initialValue={stockSize.allowedQuantity}
                                                        >
                                                          <Input
                                                            placeholder="Allowed Limit"
                                                            style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                            onChange={(e) => {
                                                              onAllowedQuantityChange(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), e.target.value, index)

                                                              if (form.getFieldValue([
                                                                `lower_limit${index}`,
                                                              ]))
                                                                form.validateFields([
                                                                  `lower_limit${index}`,
                                                                ]);
                                                              if (form.getFieldValue([
                                                                `upper_limit${index}`,
                                                              ]))
                                                                form.validateFields([
                                                                  `upper_limit${index}`,
                                                                ]);
                                                            }
                                                            }
                                                          />
                                                        </Form.Item>
                                                        <Form.Item name={`allowed-quantity_unit${index}`} noStyle initialValue={stockSize.units.quantity}>
                                                          <Select
                                                            style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                            dropdownStyle={{ minWidth: 70 }}
                                                            suffixIcon={<DownArrowDraw />}
                                                            onChange={() => {
                                                              form.validateFields([`allowed-quantity${index}`]);
                                                              if (form.getFieldValue([
                                                                `lower_limit${index}`,
                                                              ]))
                                                                form.validateFields([
                                                                  `lower_limit${index}`,
                                                                ]);
                                                              if (form.getFieldValue([
                                                                `upper_limit${index}`,
                                                              ]))
                                                                form.validateFields([
                                                                  `upper_limit${index}`,
                                                                ]);
                                                              onAllowedQuantityChange(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), form.getFieldValue(`allowed-quantity${index}`), index)
                                                            }}
                                                          >
                                                            {unitData.units_management.weight.data.map((weight) => (<Option key={weight}>{weightUnit[weight].displayName}</Option>))}
                                                          </Select>
                                                        </Form.Item>
                                                      </Input.Group>
                                                    </Form.Item>
                                                  </div>
                                                </Col>
                                                <Col span={4}>
                                                  <div
                                                    className="boxFormType"
                                                    style={{
                                                      marginBottom: "0",
                                                      marginTop: "40px",
                                                      display: "flex",
                                                      justifyContent: "flex-start",
                                                    }}
                                                  >
                                                    <Styled style={{ display: "inline-flex" }}>
                                                      <Tooltip
                                                        placement="bottomRight"
                                                        title={
                                                          stockSize.sheets ? stockSize.sheets + ' Sheets' : '-'
                                                        }
                                                      >
                                                        <span style={{ width: "16px", height: "16px" }} className="infoIcon"></span>
                                                      </Tooltip>
                                                    </Styled>
                                                  </div>
                                                </Col>
                                              </Row>

                                              {isRequiredStock && (
                                                <Row
                                                  style={{ width: "100%", marginBottom: '20px' }}
                                                  className=" "
                                                >
                                                  <Col
                                                    style={{ paddingRight: "5px" }}
                                                    span={10}
                                                  >
                                                    <div
                                                      className="boxFormType"
                                                      style={{ marginBottom: "0" }}
                                                    >
                                                      <Form.Item
                                                        label={"Lower Limit"}
                                                        className="dBlock"
                                                        style={{ marginBottom: 0 }}
                                                      >
                                                        <Input.Group compact>
                                                          <Form.Item
                                                            name={`lower_limit${index}`}
                                                            noStyle
                                                            rules={[
                                                              {
                                                                required: true,
                                                                message:
                                                                  "This field is required",
                                                              },
                                                              {
                                                                pattern: new RegExp(
                                                                  /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                                ),
                                                                message:
                                                                  "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                              },
                                                              {
                                                                validator: (
                                                                  _,
                                                                  value
                                                                ) => {
                                                                  if (
                                                                    conversionFactorUnitsToTonne[
                                                                    form.getFieldValue(
                                                                      `allowed-quantity_unit${index}`
                                                                    )
                                                                    ] *
                                                                    parseFloat(
                                                                      form.getFieldValue(
                                                                        `allowed-quantity${index}`
                                                                      )
                                                                    ) <
                                                                    conversionFactorUnitsToTonne[
                                                                    form.getFieldValue(
                                                                      `lower_unit${index}`
                                                                    )
                                                                    ] *
                                                                    parseFloat(
                                                                      value
                                                                    )
                                                                  ) {
                                                                    return Promise.reject(
                                                                      "Lower limit should be less than or equal to Allowed Quantity"
                                                                    );
                                                                  } else {
                                                                    return Promise.resolve();
                                                                  }
                                                                },
                                                              },
                                                            ]}
                                                            initialValue={stockSize.weight_lb}
                                                          >
                                                            <Input
                                                              placeholder="Lower Limit"
                                                              style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                              onChange={(e) => calculateLowerLimitSheets(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), e.target.value, index)}
                                                            />
                                                          </Form.Item>
                                                          <Form.Item name={`lower_unit${index}`} noStyle initialValue={stockSize.units.weight_lb}>
                                                            <Select
                                                              style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                              suffixIcon={<DownArrowDraw />}
                                                              dropdownStyle={{ minWidth: 70 }}
                                                              onChange={() => {
                                                                if (form.getFieldValue([`lower_limit${index}`])) form.validateFields([`lower_limit${index}`]);
                                                                calculateLowerLimitSheets(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), form.getFieldValue(`lower_limit${index}`), index)
                                                              }}
                                                            >
                                                              {unitData.units_management.weight.data.map((weight) => (<Option key={weight}>{weightUnit[weight].displayName}</Option>))}
                                                            </Select>
                                                          </Form.Item>
                                                        </Input.Group>
                                                      </Form.Item>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    style={{ paddingRight: "5px" }}
                                                    span={10}
                                                  >
                                                    <div
                                                      className="boxFormType"
                                                      style={{ marginBottom: "0" }}
                                                    >
                                                      <Form.Item
                                                        label={"Upper Limit"}
                                                        className="dBlock"
                                                        style={{ marginBottom: 0 }}
                                                      >
                                                        <Input.Group compact>
                                                          <Form.Item
                                                            name={`upper_limit${index}`}
                                                            noStyle
                                                            rules={[
                                                              {
                                                                required: true,
                                                                message:
                                                                  "This field is required",
                                                              },
                                                              {
                                                                pattern: new RegExp(
                                                                  /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                                ),
                                                                message:
                                                                  "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                              },
                                                              {
                                                                validator: (
                                                                  _,
                                                                  value
                                                                ) => {
                                                                  if (
                                                                    conversionFactorUnitsToTonne[
                                                                    form.getFieldValue(
                                                                      `allowed-quantity_unit${index}`
                                                                    )
                                                                    ] *
                                                                    parseFloat(
                                                                      form.getFieldValue(
                                                                        `allowed-quantity${index}`
                                                                      )
                                                                    ) >
                                                                    conversionFactorUnitsToTonne[
                                                                    form.getFieldValue(
                                                                      `upper_unit${index}`
                                                                    )
                                                                    ] *
                                                                    parseFloat(
                                                                      value
                                                                    )
                                                                  ) {
                                                                    return Promise.reject(
                                                                      "Upper limit should be greater than or equal to Allowed Quantity"
                                                                    );
                                                                  } else {
                                                                    return Promise.resolve();
                                                                  }
                                                                },
                                                              },
                                                            ]}

                                                            initialValue={stockSize.weight_ub}
                                                          >
                                                            <Input
                                                              placeholder="Upper Limit"
                                                              style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                              onChange={(e) => {
                                                                calculateUpperLimitSheets(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), e.target.value, index)
                                                              }
                                                              }
                                                            />
                                                          </Form.Item>
                                                          <Form.Item name={`upper_unit${index}`} noStyle initialValue={stockSize.units.weight_ub}>
                                                            <Select
                                                              style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                              dropdownStyle={{ minWidth: 70 }}
                                                              suffixIcon={<DownArrowDraw />}
                                                              onChange={() => {
                                                                if (form.getFieldValue([`upper_limit${index}`])) form.validateFields([`upper_limit${index}`]);
                                                                calculateUpperLimitSheets(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), form.getFieldValue(`upper_limit${index}`), index)
                                                              }}
                                                            >
                                                              {unitData.units_management.weight.data.map((weight) => (<Option key={weight}>{weightUnit[weight].displayName}</Option>))}
                                                            </Select>
                                                          </Form.Item>
                                                        </Input.Group>
                                                      </Form.Item>
                                                    </div>
                                                  </Col>
                                                  <Col span={4}>
                                                    <div
                                                      className="boxFormType"
                                                      style={{
                                                        marginBottom: "0",
                                                        marginTop: "40px",
                                                        display: "flex",
                                                        justifyContent: "flex-start",
                                                      }}
                                                    >
                                                      <Styled style={{ display: "inline-flex" }}>
                                                        <Tooltip
                                                          placement="bottomRight"
                                                          title={
                                                            (stockSize.upperSheets ? `Upper: ${stockSize.upperSheets} Sheets` : 'Upper: -') +
                                                            '\n' +
                                                            (stockSize.lowerSheets ? `Lower: ${stockSize.lowerSheets} Sheets` : 'Lower: -')
                                                          }
                                                        >
                                                          <span style={{ width: "16px", height: "16px" }} className="infoIcon"></span>
                                                        </Tooltip>
                                                      </Styled>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              )}

                                              {/* <Row
                                                style={{ width: "100%" }}
                                                className=" ">
                                                <div className="checklist-address">
                                                  <Checkbox
                                                    type="checkbox"
                                                    value={stockSize.isGrainChanged}
                                                    checked={stockSize.isGrainChanged}
                                                    onChange={(e) => changeGrain(e, index)}
                                                  >
                                                    <span
                                                      style={{
                                                        fontSize: "12px",
                                                        fontStyle: "normal",
                                                        lineHeight: "20px",
                                                        fontFamily: "var(--sf-pro-text)",
                                                        color: "var(--para-text)",
                                                        margin: "0",
                                                      }}
                                                    >
                                                      Allow grain change
                                                    </span>
                                                  </Checkbox>
                                                </div>
                                              </Row> */}

                                              {isRequiredStock && (
                                                <Row
                                                  style={{ width: "100%" }}
                                                  className=" ">
                                                  <div className="checklist-address">
                                                    <Checkbox
                                                      type="checkbox"
                                                      value={stockSize.priority_stock}
                                                      checked={stockSize.priority_stock}
                                                      onChange={(e) => changePriority(e, index)}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "12px",
                                                          fontStyle: "normal",
                                                          lineHeight: "20px",
                                                          fontFamily: "var(--sf-pro-text)",
                                                          color: "var(--para-text)",
                                                          margin: "0",
                                                        }}
                                                      >
                                                        It’s a Priority Stock
                                                      </span>
                                                    </Checkbox>
                                                  </div>
                                                </Row>
                                              )}
                                            </>
                                          )}
                                          {isDynamicStock &&
                                            index == stockSizes.length - 1 && (
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns: "repeat(2, auto)",
                                                  alignItems: "center",
                                                  columnGap: "24px",
                                                  rowGap: "12px",
                                                  marginTop: "20px",
                                                }}
                                              >
                                                {/* Row 1 */}
                                                <Button
                                                  className="textTypeBtn textBtnIcon"
                                                  style={{
                                                    background: "none",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                    margin: "0",
                                                  }}
                                                  onClick={() => onAddStock("reel")}
                                                >
                                                  <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                                  Add new reel stock
                                                </Button>

                                                <Button
                                                  className="textTypeBtn textBtnIcon"
                                                  style={{
                                                    background: "none",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                  }}
                                                  onClick={() => onAddStock("sheet")}
                                                >
                                                  <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                                  Add new sheet stock
                                                </Button>

                                                {/* Row 2 */}
                                                <Button
                                                  className="textTypeBtn textBtnIcon"
                                                  style={{
                                                    background: "none",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                    margin: "0",
                                                  }}
                                                  onClick={() => onAddRequiredStock("reel")}
                                                >
                                                  <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                                  Add required reel stock
                                                </Button>

                                                <Button
                                                  className="textTypeBtn textBtnIcon"
                                                  style={{
                                                    background: "none",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                  }}
                                                  onClick={() => onAddRequiredStock("sheet")}
                                                >
                                                  <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                                  Add required sheet stock
                                                </Button>
                                              </div>


                                            )}
                                        </Row>
                                      ) :
                                        (
                                          <Row className="centerAlign" key={index}>
                                            <Row style={{ width: "100%" }}>
                                              <Col span={18}>
                                                <div className="removeStar">
                                                  <label>
                                                    {stockSize.stockSize
                                                      ? `${stockSize.stockSize}`
                                                      : isRequiredStock
                                                        ? "New Required Stock"
                                                        : "New Stock"}
                                                  </label>
                                                  {!stockSize.isEdit && (
                                                    <p>
                                                      {isExistingStock && (
                                                        <span style={{ width: "180px", display: "inline-block" }}>
                                                          Available Limit : {stockSize.availableLimit} {capitalize(weightUnit[stockSize.availableUnit]?.displayName)}
                                                        </span>
                                                      )}
                                                      <span>
                                                        Allowed Limit : {stockSize.allowedQuantity} {capitalize(weightUnit[stockSize.units.quantity]?.displayName)}
                                                      </span>
                                                    </p>
                                                  )}
                                                </div>
                                              </Col>
                                              <Col span={6}>
                                                <div className="actionBtn">
                                                  {!stockSize.isEdit && (
                                                    <GlobalSet style={{ display: "flex", justifyContent: "flex-end" }}>
                                                      <Styled>
                                                        <Tooltip title="Edit Stock">
                                                          <Button className="textTypeBtn" onClick={() => handleEdit(index)}>
                                                            <Iconmoon icon="edit" size={16} color="#A19F9D" />
                                                          </Button>
                                                        </Tooltip>
                                                      </Styled>
                                                      <Styled>
                                                        <Tooltip title={stockSize.isSelected ? "Remove Stock" : "Add Stock"}>
                                                          <Switch
                                                            checked={stockSize.isSelected}
                                                            onChange={() => handleSwitchChange(index)}
                                                            className="switch-new"
                                                          />
                                                        </Tooltip>
                                                      </Styled>
                                                    </GlobalSet>
                                                  )}
                                                </div>
                                              </Col>
                                            </Row>

                                            {stockSize.isEdit && (
                                              <>
                                                <Row style={{ width: "100%", marginBottom: "10px" }}>
                                                  {/* Size field: disabled for existing, editable for new/required */}
                                                  <Col span={10} style={{ paddingRight: "5px" }} >
                                                    <Form.Item label="Size" className="dBlock">
                                                      <Input.Group compact>
                                                        <Form.Item
                                                          name={`width${index}`}
                                                          noStyle
                                                          initialValue={stockSize.width}
                                                          rules={[
                                                            { required: true, message: "This field is required" },
                                                            { pattern: new RegExp(/^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/), message: "Only Numeric characters greater than zero are allowed upto 3 decimal point" }
                                                          ]}
                                                        >
                                                          <Input
                                                            placeholder="Size"
                                                            style={{
                                                              width: "calc(100% - 70px)",
                                                              borderTopRightRadius: 0,
                                                              borderBottomRightRadius: 0,
                                                              cursor: isExistingStock ? "not-allowed" : undefined
                                                            }}
                                                            readOnly={isExistingStock}
                                                          />
                                                        </Form.Item>
                                                        <Form.Item
                                                          name={`width_unit${index}`}
                                                          noStyle
                                                          initialValue={stockSize.units.width}
                                                        >
                                                          <Select
                                                            style={{
                                                              width: 70,
                                                              borderTopLeftRadius: 0,
                                                              borderBottomLeftRadius: 0,
                                                              cursor: isExistingStock ? "not-allowed" : undefined
                                                            }}
                                                            open={isExistingStock ? false : undefined}
                                                            dropdownStyle={{ minWidth: 70 }}
                                                            suffixIcon={isExistingStock ? null : <DownArrowDraw />}
                                                          >
                                                            {unitData.units_management.length.data.map((length) => (
                                                              <Option key={length}>{lengthUnit[length].displayName}</Option>
                                                            ))}
                                                          </Select>
                                                        </Form.Item>
                                                      </Input.Group>
                                                    </Form.Item>
                                                  </Col>
                                                  {/* Allowed Limit */}
                                                  <Col span={10}>
                                                    <Form.Item
                                                      label="Allowed Limit"
                                                      className="dBlock"
                                                      style={{ marginBottom: 0 }}
                                                      extra={
                                                        isExistingStock && (
                                                          <span style={{ color: "var(--para-text)", fontSize: "12px" }}>
                                                            Available Limit: {stockSize.availableLimit} {weightUnit[stockSize.availableUnit]?.displayName?.toUpperCase()}
                                                          </span>
                                                        )
                                                      }
                                                    >
                                                      <Input.Group compact>
                                                        <Form.Item
                                                          name={`allowed-quantity${index}`}
                                                          noStyle
                                                          initialValue={stockSize.allowedQuantity}
                                                          rules={[
                                                            {
                                                              required: true,
                                                              message:
                                                                "This field is required",
                                                            },
                                                            {
                                                              pattern: new RegExp(
                                                                /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                              ),
                                                              message:
                                                                "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                            },
                                                            {
                                                              validator: (
                                                                _,
                                                                value
                                                              ) => {
                                                                if (
                                                                  conversionFactorUnitsToTonne[
                                                                  stockSize.units
                                                                    .quantity
                                                                  ] *
                                                                  parseFloat(
                                                                    stockSize.availableLimit
                                                                  ) <
                                                                  conversionFactorUnitsToTonne[
                                                                  form.getFieldValue(
                                                                    `allowed-quantity_unit${index}`
                                                                  )
                                                                  ] *
                                                                  parseFloat(
                                                                    value
                                                                  )
                                                                ) {
                                                                  return Promise.reject(
                                                                    "Allowed Qty should be less than or equal to Available Limit"
                                                                  );
                                                                } else {
                                                                  return Promise.resolve();
                                                                }
                                                              },
                                                            },
                                                          ]}
                                                        >
                                                          <Input
                                                            placeholder="Allowed Limit"
                                                            onChange={(e) => {

                                                              if (form.getFieldValue([
                                                                `lower_limit${index}`,
                                                              ]))
                                                                form.validateFields([
                                                                  `lower_limit${index}`,
                                                                ]);
                                                              if (form.getFieldValue([
                                                                `upper_limit${index}`,
                                                              ]))
                                                                form.validateFields([
                                                                  `upper_limit${index}`,
                                                                ]);
                                                            }
                                                            }
                                                            style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                          />
                                                        </Form.Item>
                                                        <Form.Item
                                                          name={`allowed-quantity_unit${index}`}
                                                          noStyle
                                                          initialValue={stockSize.units.quantity}
                                                        >
                                                          <Select
                                                            style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                            dropdownStyle={{ minWidth: 70 }}
                                                            suffixIcon={<DownArrowDraw />}
                                                            onChange={(e) => {

                                                              if (form.getFieldValue([
                                                                `lower_limit${index}`,
                                                              ]))
                                                                form.validateFields([
                                                                  `lower_limit${index}`,
                                                                ]);
                                                              if (form.getFieldValue([
                                                                `upper_limit${index}`,
                                                              ]))
                                                                form.validateFields([
                                                                  `upper_limit${index}`,
                                                                ]);
                                                            }
                                                            }
                                                          >
                                                            {unitData.units_management.weight.data.map((weight) => (
                                                              <Option key={weight}>{weightUnit[weight].displayName}</Option>
                                                            ))}
                                                          </Select>
                                                        </Form.Item>
                                                      </Input.Group>
                                                    </Form.Item>
                                                  </Col>
                                                  {/* Save/Cancel Buttons */}
                                                  <Col span={4}>
                                                    <div
                                                      className="boxFormType"
                                                      style={{
                                                        marginBottom: "0",
                                                        marginTop: "33px",
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                      }}
                                                    >
                                                      <Tooltip
                                                        title={
                                                          "Save the entered value"
                                                        }
                                                      >
                                                        <Button
                                                          key="1"
                                                          className="edit-btn"
                                                          style={{
                                                            padding: "0px",
                                                            margin: "0px",
                                                            width: "28px",
                                                            border: "none",
                                                            display: "inline-block",
                                                            marginRight: "10px",
                                                          }}
                                                          onClick={() =>
                                                            onSaveChages(index)
                                                          }
                                                        >
                                                          <Iconmoon
                                                            icon="check"
                                                            size={18}
                                                            color="#3FBD61"
                                                          />
                                                        </Button>
                                                      </Tooltip>

                                                      <Tooltip
                                                        title={"Delete the stock"}
                                                      >
                                                        <Button
                                                          key="2"
                                                          className="edit-btn"
                                                          style={{
                                                            padding: "0px",
                                                            margin: "0px",
                                                            width: "28px",
                                                            border: "none",
                                                            display: "inline-block",
                                                          }}
                                                          onClick={() =>
                                                            onDiscardChanges(index)
                                                          }
                                                        >
                                                          <Iconmoon
                                                            icon="cancel"
                                                            size={18}
                                                            color="red"
                                                          />
                                                        </Button>
                                                      </Tooltip>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                {/* Required stock extra fields */}
                                                {isRequiredStock && (
                                                  <>
                                                    <Row style={{ width: "100%", marginBottom: "20px" }}>
                                                      <Col style={{ paddingRight: "5px" }} span={10}>
                                                        <div className="boxFormType" style={{ marginBottom: "0" }}>
                                                          <Form.Item label="Lower Limit" className="dBlock" style={{ marginBottom: 0 }}>
                                                            <Input.Group compact>
                                                              <Form.Item
                                                                name={`lower_limit${index}`}
                                                                noStyle
                                                                initialValue={stockSize.weight_lb}
                                                                rules={[
                                                                  {
                                                                    required: true,
                                                                    message:
                                                                      "This field is required",
                                                                  },
                                                                  {
                                                                    pattern: new RegExp(
                                                                      /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                                    ),
                                                                    message:
                                                                      "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                                  },
                                                                  {
                                                                    validator: (
                                                                      _,
                                                                      value
                                                                    ) => {
                                                                      if (
                                                                        conversionFactorUnitsToTonne[
                                                                        form.getFieldValue(
                                                                          `allowed-quantity_unit${index}`
                                                                        )
                                                                        ] *
                                                                        parseFloat(
                                                                          form.getFieldValue(
                                                                            `allowed-quantity${index}`
                                                                          )
                                                                        ) <
                                                                        conversionFactorUnitsToTonne[
                                                                        form.getFieldValue(
                                                                          `lower_unit${index}`
                                                                        )
                                                                        ] *
                                                                        parseFloat(
                                                                          value
                                                                        )
                                                                      ) {
                                                                        return Promise.reject(
                                                                          "Lower limit should be less than or equal to Allowed Quantity"
                                                                        );
                                                                      } else {
                                                                        return Promise.resolve();
                                                                      }
                                                                    },
                                                                  },
                                                                ]}
                                                              >
                                                                <Input
                                                                  placeholder="Lower Limit"
                                                                  style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                                />
                                                              </Form.Item>
                                                              <Form.Item
                                                                name={`lower_unit${index}`}
                                                                noStyle
                                                                initialValue={stockSize.units.weight_lb}
                                                              >
                                                                <Select
                                                                  onChange={(e) => {
                                                                    if (form.getFieldValue([
                                                                      `lower_limit${index}`,
                                                                    ]))
                                                                      form.validateFields([
                                                                        `lower_limit${index}`,
                                                                      ]);

                                                                  }}
                                                                  style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                                  suffixIcon={<DownArrowDraw />}
                                                                  dropdownStyle={{ minWidth: 70 }}
                                                                >
                                                                  {unitData.units_management.weight.data.map((weight) => (
                                                                    <Option key={weight}>{weightUnit[weight].displayName}</Option>
                                                                  ))}
                                                                </Select>
                                                              </Form.Item>
                                                            </Input.Group>
                                                          </Form.Item>
                                                        </div>
                                                      </Col>
                                                      <Col style={{ paddingRight: "5px" }} span={10}>
                                                        <div className="boxFormType" style={{ marginBottom: "0" }}>
                                                          <Form.Item label="Upper Limit" className="dBlock" style={{ marginBottom: 0 }}>
                                                            <Input.Group compact>
                                                              <Form.Item
                                                                name={`upper_limit${index}`}
                                                                noStyle
                                                                initialValue={stockSize.weight_ub}
                                                                rules={[
                                                                  {
                                                                    required: true,
                                                                    message:
                                                                      "This field is required",
                                                                  },
                                                                  {
                                                                    pattern: new RegExp(
                                                                      /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                                    ),
                                                                    message:
                                                                      "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                                  },
                                                                  {
                                                                    validator: (
                                                                      _,
                                                                      value
                                                                    ) => {
                                                                      if (
                                                                        conversionFactorUnitsToTonne[
                                                                        form.getFieldValue(
                                                                          `allowed-quantity_unit${index}`
                                                                        )
                                                                        ] *
                                                                        parseFloat(
                                                                          form.getFieldValue(
                                                                            `allowed-quantity${index}`
                                                                          )
                                                                        ) >
                                                                        conversionFactorUnitsToTonne[
                                                                        form.getFieldValue(
                                                                          `upper_unit${index}`
                                                                        )
                                                                        ] *
                                                                        parseFloat(
                                                                          value
                                                                        )
                                                                      ) {
                                                                        return Promise.reject(
                                                                          "Upper limit should be greater than or equal to Allowed Quantity"
                                                                        );
                                                                      } else {
                                                                        return Promise.resolve();
                                                                      }
                                                                    },
                                                                  },
                                                                ]}

                                                              >
                                                                <Input
                                                                  placeholder="Upper Limit"
                                                                  style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                                />
                                                              </Form.Item>
                                                              <Form.Item
                                                                name={`upper_unit${index}`}
                                                                noStyle
                                                                initialValue={stockSize.units.weight_ub}
                                                              >
                                                                <Select
                                                                  style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                                  dropdownStyle={{ minWidth: 70 }}
                                                                  suffixIcon={<DownArrowDraw />

                                                                  }
                                                                  onChange={(e) => {
                                                                    if (form.getFieldValue([
                                                                      `lower_limit${index}`,
                                                                    ]))
                                                                      form.validateFields([
                                                                        `lower_limit${index}`,
                                                                      ]);
                                                                  }
                                                                  }
                                                                >
                                                                  {unitData.units_management.weight.data.map((weight) => (
                                                                    <Option key={weight}>{weightUnit[weight].displayName}</Option>
                                                                  ))}
                                                                </Select>
                                                              </Form.Item>
                                                            </Input.Group>
                                                          </Form.Item>
                                                        </div>
                                                      </Col>

                                                    </Row>
                                                    <Row style={{ width: "100%" }}>
                                                      <div className="checklist-address">
                                                        <Checkbox
                                                          type="checkbox"
                                                          value={stockSize.priority_stock}
                                                          checked={stockSize.priority_stock}
                                                          onChange={e => changePriority(e, index)}
                                                        >
                                                          <span
                                                            style={{
                                                              fontSize: "12px",
                                                              fontStyle: "normal",
                                                              lineHeight: "20px",
                                                              fontFamily: "var(--sf-pro-text)",
                                                              color: "var(--para-text)",
                                                              margin: "0",
                                                            }}
                                                          >
                                                            It’s a Priority Stock
                                                          </span>
                                                        </Checkbox>
                                                      </div>
                                                    </Row>
                                                  </>
                                                )}
                                              </>
                                            )}

                                            {isDynamicStock &&
                                              index == stockSizes.length - 1 && (
                                                <div
                                                  style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "repeat(2, auto)",
                                                    alignItems: "center",
                                                    columnGap: "24px",
                                                    rowGap: "12px",
                                                    marginTop: "20px",
                                                  }}
                                                >
                                                  {/* Row 1 */}
                                                  <Button
                                                    className="textTypeBtn textBtnIcon"
                                                    style={{
                                                      background: "none",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "6px",
                                                      margin: "0",
                                                    }}
                                                    onClick={() => onAddStock("reel")}
                                                  >
                                                    <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                                    Add new reel stock
                                                  </Button>

                                                  <Button
                                                    className="textTypeBtn textBtnIcon"
                                                    style={{
                                                      background: "none",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "6px",
                                                    }}
                                                    onClick={() => onAddStock("sheet")}
                                                  >
                                                    <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                                    Add new sheet stock
                                                  </Button>

                                                  {/* Row 2 */}
                                                  <Button
                                                    className="textTypeBtn textBtnIcon"
                                                    style={{
                                                      background: "none",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "6px",
                                                      margin: "0",
                                                    }}
                                                    onClick={() => onAddRequiredStock("reel")}
                                                  >
                                                    <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                                    Add required reel stock
                                                  </Button>

                                                  <Button
                                                    className="textTypeBtn textBtnIcon"
                                                    style={{
                                                      background: "none",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "6px",
                                                    }}
                                                    onClick={() => onAddRequiredStock("sheet")}
                                                  >
                                                    <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                                    Add required sheet stock
                                                  </Button>
                                                </div>



                                              )}              </Row>
                                        )
                                        ;
                                    })}
                                    {isDynamicStock && !stockSizes.length && (
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "repeat(2, auto)",
                                          alignItems: "center",
                                          columnGap: "24px",
                                          rowGap: "12px",
                                          marginTop: "20px",
                                        }}
                                      >
                                        {/* Row 1 */}
                                        <Button
                                          className="textTypeBtn textBtnIcon"
                                          style={{
                                            background: "none",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            margin: "0",
                                          }}
                                          onClick={() => onAddStock("reel")}
                                        >
                                          <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                          Add new reel stock
                                        </Button>

                                        <Button
                                          className="textTypeBtn textBtnIcon"
                                          style={{
                                            background: "none",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                          onClick={() => onAddStock("sheet")}
                                        >
                                          <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                          Add new sheet stock
                                        </Button>

                                        {/* Row 2 */}
                                        <Button
                                          className="textTypeBtn textBtnIcon"
                                          style={{
                                            background: "none",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            margin: "0",
                                          }}
                                          onClick={() => onAddRequiredStock("reel")}
                                        >
                                          <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                          Add required reel stock
                                        </Button>

                                        <Button
                                          className="textTypeBtn textBtnIcon"
                                          style={{
                                            background: "none",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                          onClick={() => onAddRequiredStock("sheet")}
                                        >
                                          <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                                          Add required sheet stock
                                        </Button>
                                      </div>



                                    )}
                                  </>
                                </Col>
                              </Row>
                            </PaperBlockList>
                          </Col>
                        </Row>
                      </div>
                      {/* <div className="groupDetailWrap">
                      <Row gutter={[16, 16]} className="groupForm">
                        <Col span={10}>
                          <div
                            className="boxFieldTitle"
                            style={{ marginTop: "20px" }}
                          >
                            <label>Select Run Type</label>
                            <p>
                              Select if you would like to include specific sizes
                              quantity or let the system decide the optimum size
                              and quantity
                            </p>
                          </div>
                        </Col>
                        <Col span={14}>
                          <div
                            className="boxFormType switchRadio extraWidth"
                            style={{
                              justifyContent: "flex-start",
                              display: "flex",
                              marginTop: "20px",
                              marginLeft: "5%",
                            }}
                          >
                            <Form.Item
                              name="status"
                              className=""
                              initialValue={
                                createNewSolutionFormValuesForSizes?.status
                                  ? createNewSolutionFormValuesForSizes?.status
                                  : "selectedSizes"
                              }
                            >
                              <Radio.Group
                                options={runTypes}
                                onChange={handleRunTypeChange}
                                optionType="button"
                                buttonStyle="solid"
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="italicsTitleWithText"
                            style={{
                              justifyContent: "flex-start",
                              display: "flex",
                              marginLeft: "5%",
                            }}
                          >
                            <p>
                              You can select the size and maximum allowed
                              quantity to process
                            </p>
                          </div>
                        </Col>
                      </Row>

                      <Row gutter={[16, 16]} className="groupForm">
                        <Col span={10}>
                          <div
                            className="boxFieldTitle"
                            style={{ marginTop: "20px" }}
                          >
                            <label>Select Stock Sizes</label>
                            <p>
                              Select the sizes and quantity to process with
                              orders
                            </p>
                          </div>
                        </Col>
                        <Col span={14}>
                          {stockSizes.map((stockSize, index) => {
                            return (
                              <Row gutter={[16, 16]} className="centerAlign">
                                <Col span={18}>
                                <div className="boxFieldTitle">
                                    <label>{stockSize.stockSize + " " + (lengthUnit[stockSize.units.width].displayName).toUpperCase() + (stockSize.stockDefaultSize ? ( ' ( ' + stockSize.stockDefaultSize + ' )'):'')}</label>
                                    <p>
                                      Available Limit :{" "}
                                      {stockSize.availableLimit + " " +  capitalize(weightUnit[stockSize.units.quantity].displayName)+ (stockSize.availableDefaultLimit ? ( ' ( ' + stockSize.availableDefaultLimit + ' )'):'')}
                                    </p>
                                  </div>
                                </Col>
                                <Col span={6}>
                                  <div className="boxFormType">
                                    <GlobalSet>
                                      <Styled>
                                        <Tooltip
                                          placement="bottomRight"
                                          title={
                                            stockSize.isSelected
                                              ? "Remove Stock"
                                              : "Add Stock"
                                          }
                                          getPopupContainer={(triggerNode) =>
                                            triggerNode
                                          }
                                        >
                                          <Switch
                                            checked={stockSize.isSelected}
                                            onChange={() =>
                                              handleSwitchChange(index)
                                            }
                                            className="switch-new"
                                            disabled={false}
                                          />
                                        </Tooltip>
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                                {stockSize.isSelected && (
                                  <div
                                    className="boxFormType switchRadio extraWidth"
                                    style={{
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <div className="boxFormType" style={{alignSelf: "flex-start",width:'117px'}}>
                                    <p
                                        style={{
                                          marginLeft: "3px",
                                        }}
                                      >
                                        Rotation
                                      </p>
                                      <Form.Item
                                        name={`rotated${index}`}
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                        ]}
                                        initialValue={
                                          "Enabled"
                                        }
                                        className="dBlock"
                                        style={{ marginLeft: "3px" }}
                                      >
                                        <Select
                                        defaultValue={"Enabled"}
                                          placeholder={"Select"}
                                          suffixIcon={<DownArrowDraw />}
                                          // onChange={findPlannedReels}
                                          onChange={(e) =>
                                            handleRotate(
                                            e,index  
                                            )
                                          }
                                        >
                                          {rotationData.map((rotation) => (
                                            <Option key={rotation}>
                                              {rotation}
                                            </Option>
                                          ))}
                                        </Select>{" "}
                                      </Form.Item>
                                    </div>
                                    <div className="boxFormType" style={{alignSelf: "flex-start"}}>
                                    <p style={{ marginLeft: "3px" }}>
                                        Allowed quantity {'(' + capitalize(weightUnit[stockSize.units.quantity].displayName) + ')'}
                                      </p>
                                      <Form.Item
                                        name={`allowed-quantity${index}`}
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only numerical values are allowed",
                                          },
                                          {
                                            validator: (_, value) => {
                                              if (
                                              parseFloat( stockSize.availableLimit ) < parseFloat( value )
                                              ) {
                                                return Promise.reject(
                                                  "Allowed Qty should be less than or equal to Available Limit"
                                                );
                                              } else {
                                                return Promise.resolve();
                                              }
                                            },
                                          },
                                        ]}
                                        initialValue={
                                          createNewSolutionFormValuesForSizes?.selectedSizes
                                            ? (createNewSolutionFormValuesForSizes?.selectedSizes.filter(
                                                (size) =>
                                                  size.stockSizeId ==
                                                  stockSize.stockSizeId
                                              )).length > 0
                                              ? toFixedValue(parseFloat((createNewSolutionFormValuesForSizes?.selectedSizes.filter(
                                                  (size) =>
                                                    size.stockSizeId ==
                                                    stockSize.stockSizeId
                                                ))[0]?.allowedQuantity),3)
                                              : toFixedValue(stockSize.availableLimit,3)
                                            : toFixedValue(stockSize.availableLimit,3)
                                        }
                                        className="dBlock"
                                        style={{ marginLeft: "3px" }}
                                      >
                                        <Input
                                          placeholder=""
                                          onChange={(e) =>
                                            onAllowedQuantityChange(
                                              stockSize.length,
                                              stockSize.width,
                                              e.target.value,
                                              index
                                            )
                                          }
                                         
                                        />
                                      </Form.Item>
                                    </div>
                                    <div className="boxFormType" style={{alignSelf: "flex-start",width:'280px'}}>
                                    <p style={{ marginLeft: "3px" }}>
                                        Sheets
                                      </p>
                                      <Form.Item
                                        name={`sheets${index}`}
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only numerical values are allowed",
                                          },
                                        ]}
                                        // initialValue={}
                                        className="dBlock"
                                        style={{ marginLeft: "3px" }}
                                      >
                                        <Input
                                          placeholder=""
                                          onChange={(e) =>
                                            calculatePlannedWeight(
                                              stockSize.length,
                                              stockSize.width,
                                              e.target.value,
                                              index
                                            )
                                          }
                                        />
                                      </Form.Item>
                                     </div>
                                    <div className="boxFormType" style={{alignSelf: "flex-start"}}>
                                    <p style={{ marginLeft: "3px" }}>
                                        Planned Weight {'(' + capitalize(weightUnit[stockSize.units.quantity].displayName) + ')'}
                                      </p>
                                      <Form.Item
                                        name={`planned-weight${index}`}
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                          // {
                                          //   validator: (_, value) => {
                                          //     if (stockSize.availableLimit < value) {
                                          //       return Promise.reject('Planned Weight should be less than or equal to Available Limit');
                                          //     }
                                          //     else {
                                          //       return Promise.resolve();
                                          //     }
                                          //   }
                                          // }
                                        ]}
                                        // initialValue={""}
                                        className="dBlock"
                                        style={{ marginLeft: "3px" }}
                                      >
                                        <Input placeholder="" disabled 
                                       
                                        />
                                      </Form.Item>
                                      {stockSize.plannedWeightError ? (
                                        <div
                                          className="errorText"
                                          style={{
                                            color: "#ea4e2c",
                                            paddingLeft: "20px",
                                          }}
                                        >
                                          {stockSize.plannedWeightError}
                                        </div>
                                      ) : null}
                                      
                                    </div>
                                  </div>
                                )}
                              </Row>
                            );
                          })}
                        </Col>
                      </Row>
                    </div> */}
                    </>
                  </HaberForm>
                </DetailFields>
              </Panes>
              <Panes tab="Machine Details" key="2">
                <DetailFields>
                  <HaberForm>
                    <div className="groupDetailWrap">
                      <Collapse
                        className="sub-category-newsol"
                        expandIconPosition="right"
                        // defaultActiveKey={["1", "2", "3", "4"]}
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <CollapsePanel
                          key="1"
                          header={
                            <Col span={20}>
                              {" "}
                              <h1
                                style={{
                                  fontSize: "20px",
                                  paddingLeft: "10px",
                                }}
                              >
                                Rewinder Specification -{" "}
                                {
                                  jobCardDetails?.group?.machines?.filter(
                                    (item) => item.machine_type === "rewinder"
                                  )[0].rewinder_name
                                }
                              </h1>{" "}
                            </Col>
                          }
                        >
                          <Row gutter={[24]} className="groupForm">
                            <Col span={24} className="blockBreak">
                              <PaperBlockList>
                                <Row className="centerAlign">
                                  <Col span={12}>
                                    <div className="boxFieldTitleMulti removeStar">
                                      <label>Deckle Range</label>
                                      <p>
                                        Specify the minimum and maximum deckle
                                        length of the machine
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="d-flex threeFields">
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="min_deckle_length"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                          {
                                            pattern: new RegExp(
                                              /^\d+(\.\d{0,3})?$/
                                            ),
                                            message: "Invalid input",
                                          },
                                          {
                                            validator(_, value) {
                                              if (
                                                value >
                                                parseFloat(
                                                  form.getFieldValue(
                                                    "max_deckle_length"
                                                  )
                                                )
                                              ) {
                                                return Promise.reject(
                                                  "Min deckle length cannot be greater than max deckle length"
                                                );
                                              } else {
                                                return Promise.resolve();
                                              }
                                            },
                                          },

                                        ]}
                                        initialValue={
                                          formValuesForStock?.min_deckle_length
                                        }
                                        label="Min Deckle Length"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Min Deckle Length"
                                          onChange={() => {
                                            changeDeckleLength();
                                            validateFieldsOnChange(["min_deckle_length", "max_deckle_length"]);
                                          }}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="max_deckle_length"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only numerical values are allowed",
                                          },
                                          {
                                            validator(_, value) {
                                              if (
                                                value <
                                                parseFloat(
                                                  form.getFieldValue(
                                                    "min_deckle_length"
                                                  )
                                                )
                                              ) {
                                                return Promise.reject(
                                                  // "Max deckle length cannot be less than min deckle length"
                                                );
                                              } else {
                                                return Promise.resolve();
                                              }
                                            },
                                          },

                                        ]}
                                        initialValue={
                                          formValuesForStock?.max_deckle_length
                                        }
                                        label="Max Deckle Length"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Min Deckle Length"
                                          onChange={() => {
                                            validateFieldsOnChange(["min_deckle_length", "max_deckle_length"]);
                                            changeDeckleLength();
                                          }}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType unitSelect"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="deckleLengthUnit"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                        ]}
                                        label="Unit"
                                        className="dBlock"
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                          onChange={() => {
                                            changeDeckleLength();
                                          }}
                                        >
                                          {unitData?.units_management?.length?.data.map(
                                            (deckleWidth) => (
                                              <Option key={deckleWidth}>
                                                {
                                                  lengthUnit[deckleWidth]
                                                    .displayName
                                                }
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                        {/* <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      onChange={() => {
                                      }}
                                    >
                                      {deckleWidthData.map((deckleWidth) => (
                                        <Option key={deckleWidth}>
                                          {deckleWidth}
                                        </Option>
                                      ))}
                                    </Select> */}
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                              </PaperBlockList>
                              <PaperBlockList>
                                <Row className="centerAlign">
                                  <Col span={12}>
                                    <div className="boxFieldTitleMulti removeStar">
                                      <label>Edge Trim</label>
                                      <p>
                                        Specify the left and right edge trim for
                                        the machine
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="d-flex threeFields">
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="min_width"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                          {
                                            pattern: new RegExp(
                                              /^\d+(\.\d{0,3})?$/
                                            ),
                                            message: "Invalid input",
                                          },

                                          // {
                                          //   validator(_, value) {
                                          //      if (value > parseFloat(form.getFieldValue("max_width"))) {
                                          //       return Promise.reject("Min width cannot be greater than max width");
                                          //     } else {
                                          //       return Promise.resolve();
                                          //     }
                                          //   },
                                          // },
                                        ]}
                                        initialValue={
                                          formValuesForStock?.left_edge_trim
                                        }
                                        label="Left Trim"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Left trim"
                                          onChange={() => {
                                            changeDeckleLength();
                                          }}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="max_width"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                          {
                                            pattern: new RegExp(
                                              /^\d+(\.\d{0,3})?$/
                                            ),
                                            message: "Invalid input",
                                          },
                                          // , {
                                          //   validator(_, value) {
                                          //      if (value < parseFloat(form.getFieldValue("min_width"))) {
                                          //       return Promise.reject("Max width cannot be less than min width");
                                          //     } else {
                                          //       return Promise.resolve();
                                          //     }
                                          //   },
                                          // },
                                        ]}
                                        initialValue={
                                          formValuesForStock?.right_edge_trim
                                        }
                                        label="Right Trim"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Right trim"
                                          onChange={() => {
                                            changeDeckleLength();
                                          }}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType unitSelect"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="widthUnit"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                        ]}
                                        label="Unit"
                                        className="dBlock"
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                          onChange={() => {
                                            changeDeckleLength();
                                          }}
                                        >
                                          {unitData?.units_management.length.data.map(
                                            (deckleWidth) => (
                                              <Option key={deckleWidth}>
                                                {
                                                  lengthUnit[deckleWidth]
                                                    .displayName
                                                }
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                              </PaperBlockList>
                              <PaperBlockList>
                                <Row className="centerAlign">
                                  <Col span={12}>
                                    <div className="boxFieldTitleMulti">
                                      <label>Effective Deckle Length</label>
                                      <p>
                                        Available deckle length to match deckle
                                        after adjusting for edge trim
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className="boxFormType">
                                      <Form.Item
                                        name="effective_deckle_length"
                                        className=""
                                        initialValue={
                                          formValuesForStock?.effective_deckle_length *
                                          CoversionFactorUnitsToCM[
                                          formValuesForStock?.units
                                            ?.effective_deckle_length
                                          ] *
                                          CoversionFactorCMToUnits[deckleUnit]
                                        }
                                        shouldUpdate
                                      >
                                        <Input
                                          disabled
                                          placeholder="Enter Deckle Length"
                                          suffix={
                                            <label className="floating-label">
                                              {
                                                lengthUnit[deckleUnit]
                                                  ?.displayName
                                              }
                                            </label>
                                          }
                                        />
                                      </Form.Item>
                                      <p style={{ color: 'red', transform: 'translateY(-20px)' }}>{showError.message}</p>
                                    </div>
                                  </Col>
                                </Row>
                              </PaperBlockList>
                              <PaperBlockList>
                                <Row className="centerAlign">
                                  <Col span={12}>
                                    <div className="boxFieldTitleMulti">
                                      <label>Maximum Number of cutters</label>
                                      <p>
                                        Specify maximum number of cutters
                                        including edge cutters which can be placed
                                        on deckle
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className="boxFormType">
                                      <Form.Item
                                        name="cutters"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only numerical values are allowed",
                                          },
                                          {
                                            validator(_, value) {
                                              if (value == 0)
                                                return Promise.reject(
                                                  "Cutters should be more than 0"
                                                );
                                              else return Promise.resolve();
                                            },
                                          },
                                        ]}
                                        initialValue={
                                          formValuesForStock?.maximum_cutters
                                        }
                                        className=""
                                      >
                                        <Input placeholder="Maximum Number of cutters" />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                              </PaperBlockList>
                            </Col>
                          </Row>
                        </CollapsePanel>
                        <CollapsePanel
                          key="2"
                          header={
                            <Col span={20}>
                              {" "}
                              <h1
                                style={{
                                  fontSize: "20px",
                                  paddingLeft: "10px",
                                  paddingTop: "25px",
                                }}
                              >
                                Cutter Specification -{" "}
                                {
                                  jobCardDetails?.group?.machines?.filter(
                                    (item) => item.machine_type === "cutter"
                                  )[0]?.cutter_name
                                }
                              </h1>{" "}
                            </Col>
                          }
                        >
                          <Row gutter={[24]} className="groupForm">
                            <Col span={24} className="blockBreak">
                              <PaperBlockList>
                                <Row className="centerAlign">
                                  <Col span={12}>
                                    <div className="boxFieldTitleMulti removeStar">
                                      <label>Deckle Range</label>
                                      <p>
                                        Specify the minimum and maximum deckle
                                        length of the machine
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="d-flex threeFields">
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="min_deckle_length_cutter"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only numerical values are allowed",
                                          },
                                          {
                                            validator(_, value) {
                                              if (
                                                value >
                                                parseFloat(
                                                  form.getFieldValue(
                                                    "max_deckle_length_cutter"
                                                  )
                                                )
                                              ) {
                                                return Promise.reject(
                                                  "Min deckle length cannot be greater than max deckle length"
                                                );
                                              } else {
                                                return Promise.resolve();
                                              }
                                            },
                                          },

                                        ]}
                                        initialValue={
                                          formValuesForStock?.min_deckle_length_cutter
                                        }
                                        label="Min Deckle Length"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Min Deckle Length"
                                          onChange={() => {
                                            changeDeckleLengthCutter();
                                            validateFieldsOnChange(["min_deckle_length_cutter", "max_deckle_length_cutter"]);
                                          }}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="max_deckle_length_cutter"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                          {
                                            pattern: new RegExp(
                                              /^\d+(\.\d{0,3})?$/
                                            ),
                                            message: "Invalid input",
                                          },
                                          {
                                            validator(_, value) {
                                              if (
                                                value <
                                                parseFloat(
                                                  form.getFieldValue(
                                                    "min_deckle_length_cutter"
                                                  )
                                                )
                                              ) {
                                                return Promise.reject(
                                                  // "Max deckle length cannot be less than min deckle length"
                                                );
                                              } else {
                                                return Promise.resolve();
                                              }
                                            },
                                          },

                                        ]}
                                        initialValue={
                                          formValuesForStock?.max_deckle_length_cutter
                                        }
                                        label="Max Deckle Length"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Max Deckle Length"
                                          onChange={() => {
                                            changeDeckleLengthCutter();
                                            validateFieldsOnChange(["min_deckle_length_cutter", "max_deckle_length_cutter"]);
                                          }}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType unitSelect"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="deckleLengthUnit_cutter"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                        ]}
                                        label="Unit"
                                        className="dBlock"
                                        initialValue={
                                          formValuesForStock?.units_cutter
                                            ?.deckle_size_ub
                                        }
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                          onChange={() => {
                                            changeDeckleLengthCutter();
                                          }}
                                        >
                                          {unitData?.units_management?.length?.data.map(
                                            (deckleWidth) => (
                                              <Option key={deckleWidth}>
                                                {
                                                  lengthUnit[deckleWidth]
                                                    .displayName
                                                }
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                        {/* <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      onChange={() => {
                                      }}
                                    >
                                      {deckleWidthData.map((deckleWidth) => (
                                        <Option key={deckleWidth}>
                                          {deckleWidth}
                                        </Option>
                                      ))}
                                    </Select> */}
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                              </PaperBlockList>
                              <PaperBlockList>
                                <Row className="centerAlign">
                                  <Col span={12}>
                                    <div className="boxFieldTitleMulti removeStar">
                                      <label>Edge Trim</label>
                                      <p>
                                        Specify the left and right edge trim for
                                        the machine
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="d-flex threeFields">
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="min_width_cutter"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                          {
                                            pattern: new RegExp(
                                              /^\d+(\.\d{0,3})?$/
                                            ),
                                            message: "Invalid input",
                                          },

                                          // , {
                                          //   validator(_, value) {
                                          //      if (value > parseFloat(form.getFieldValue("max_width_cutter"))) {
                                          //       return Promise.reject("Min width cannot be greater than max width");
                                          //     } else {
                                          //       return Promise.resolve();
                                          //     }
                                          //   },
                                          // },
                                        ]}
                                        initialValue={
                                          formValuesForStock?.left_edge_trim_cutter
                                        }
                                        label="Left Trim"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Left trim"
                                          onChange={() => {
                                            changeDeckleLengthCutter();
                                          }}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="max_width_cutter"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                          {
                                            pattern: new RegExp(
                                              /^\d+(\.\d{0,3})?$/
                                            ),
                                            message: "Invalid input",
                                          },

                                          // , {
                                          //   validator(_, value) {
                                          //      if (value < parseFloat(form.getFieldValue("min_width_cutter"))) {
                                          //       return Promise.reject("Max width cannot be less than min width");
                                          //     } else {
                                          //       return Promise.resolve();
                                          //     }
                                          //   },
                                          // },
                                        ]}
                                        initialValue={
                                          formValuesForStock?.right_edge_trim_cutter
                                        }
                                        label="Right Trim"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Right trim"
                                          onChange={() => {
                                            changeDeckleLengthCutter();
                                          }}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType unitSelect"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="widthUnit_cutter"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                        ]}
                                        label="Unit"
                                        className="dBlock"
                                        initialValue={
                                          formValuesForStock?.units_cutter
                                            ?.left_edge_trim
                                        }
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                          onChange={() => {
                                            changeDeckleLengthCutter();
                                          }}
                                        >
                                          {unitData?.units_management.length.data.map(
                                            (deckleWidth) => (
                                              <Option key={deckleWidth}>
                                                {
                                                  lengthUnit[deckleWidth]
                                                    .displayName
                                                }
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                              </PaperBlockList>
                              <PaperBlockList>
                                <Row className="centerAlign">
                                  <Col span={12}>
                                    <div className="boxFieldTitleMulti">
                                      <label>Effective Deckle Length</label>
                                      <p>
                                        Available deckle length to match deckle
                                        after adjusting for edge trim
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className="boxFormType">
                                      <Form.Item
                                        name="effective_deckle_length_cutter"
                                        className=""
                                        initialValue={
                                          formValuesForStock?.effective_deckle_length_cutter
                                        }
                                        shouldUpdate
                                      >
                                        <Input
                                          disabled
                                          placeholder="Enter Deckle Length"
                                          suffix={
                                            <label className="floating-label">
                                              {
                                                lengthUnit[deckleUnitCutter]
                                                  ?.displayName
                                              }
                                            </label>
                                          }
                                        />
                                      </Form.Item>
                                      <p style={{ color: 'red', transform: 'translateY(-20px)' }}>{showCutterError.message}</p>
                                    </div>
                                  </Col>
                                </Row>
                              </PaperBlockList>
                              <PaperBlockList>
                                <Row className="centerAlign">
                                  <Col span={12}>
                                    <div className="boxFieldTitleMulti">
                                      <label>Maximum Number of cutters</label>
                                      <p>
                                        Specify maximum number of cutters
                                        including edge cutters which can be placed
                                        on deckle
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className="boxFormType">
                                      <Form.Item
                                        name="cutters_cutter"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only numerical values are allowed",
                                          },
                                          {
                                            validator(_, value) {
                                              if (value == 0)
                                                return Promise.reject(
                                                  "Cutters should be more than 0"
                                                );
                                              else return Promise.resolve();
                                            },
                                          },
                                        ]}
                                        initialValue={
                                          formValuesForStock?.maximum_cutters_cutter
                                        }
                                        className=""
                                      >
                                        <Input placeholder="Maximum Number of cutters" />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                              </PaperBlockList>
                              <PaperBlockList>
                                <Row className="centerAlign">
                                  <Col span={12}>
                                    <div className="boxFieldTitleMulti removeStar">
                                      <label>Chop Size Range</label>
                                      <p>
                                        Specify the minimum and maximum chop
                                        size that can be cut on this cutter
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="d-flex threeFields">
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="min_chop_cutter"
                                        rules={[
                                          // {
                                          //   required: true,
                                          //   message: "This is a required field",
                                          // },
                                          {
                                            pattern: new RegExp(
                                              /^\d+(\.\d{0,3})?$/
                                            ),
                                            message: "Invalid input",
                                          },
                                          {
                                            validator(_, value) {
                                              if (
                                                value >
                                                parseFloat(
                                                  form.getFieldValue(
                                                    "max_chop_cutter"
                                                  )
                                                )
                                              ) {
                                                return Promise.reject(
                                                  "Min chop size cannot be greater than max chop size"
                                                );
                                              } else {
                                                return Promise.resolve();
                                              }
                                            },
                                          },
                                        ]}
                                        initialValue={
                                          formValuesForStock?.min_chop_cutter
                                        }
                                        label="Min Chop Size"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Min Chop Size"
                                          onChange={() => validateFieldsOnChange(["min_chop_cutter", "max_chop_cutter"])}
                                        // onChange={() => {
                                        //   changeDeckleLength();
                                        // }}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="max_chop_cutter"
                                        rules={[
                                          // {
                                          //   required: true,
                                          //   message: "This is a required field",
                                          // },
                                          {
                                            pattern: new RegExp(
                                              /^\d+(\.\d{0,3})?$/
                                            ),
                                            message: "Invalid input",
                                          },
                                          {
                                            validator(_, value) {
                                              if (
                                                value <
                                                parseFloat(
                                                  form.getFieldValue(
                                                    "min_chop_cutter"
                                                  )
                                                )
                                              ) {
                                                return Promise.reject(
                                                  // "Max chop size cannot be less than min chop size"
                                                );
                                              } else {
                                                return Promise.resolve();
                                              }
                                            },
                                          },
                                        ]}
                                        initialValue={
                                          formValuesForStock?.max_chop_cutter
                                        }
                                        label="Max Chop Size"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Max Chop Size"
                                          onChange={() => validateFieldsOnChange(["min_chop_cutter", "max_chop_cutter"])}
                                        // onChange={() => {
                                        //   changeDeckleLength();
                                        // }}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType unitSelect"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="chopUnit"
                                        rules={
                                          [
                                            // {
                                            //   required: true,
                                            //   message: "This is a required field",
                                            // },
                                          ]
                                        }
                                        label="Unit"
                                        className="dBlock"
                                        initialValue={
                                          formValuesForStock?.units_cutter
                                            ?.max_chop_size
                                        }
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                        // onChange={() => {
                                        //   changeDeckleLength();
                                        // }}
                                        >
                                          {unitData?.units_management.length.data.map(
                                            (deckleWidth) => (
                                              <Option key={deckleWidth}>
                                                {
                                                  lengthUnit[deckleWidth]
                                                    .displayName
                                                }
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row> </PaperBlockList><PaperBlockList>
                                <Row className="centerAlign">
                                  <Col span={12}>
                                    <div className="boxFieldTitleMulti removeStar">
                                      <label>Reel Diameter Range</label>
                                      <p>
                                        Specify the minimum and maximum reel
                                        diameter that a cutter can handle
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="d-flex threeFields">
                                    <div className="boxFormType" style={{ marginBottom: "0" }}>
                                      <Form.Item
                                        name="min_dia_cutter"
                                        rules={[
                                          {
                                            pattern: new RegExp(/^(?!0(?:\.0+)?$)\d+(?:\.\d+)?$/),
                                            message: "Only numerical non-zero values are allowed",
                                          },
                                          {
                                            validator(_, value) {
                                              if (value > parseFloat(form.getFieldValue("max_dia_cutter"))) {
                                                return Promise.reject("Min dia cannot be greater than max dia");
                                              } else {
                                                return Promise.resolve();
                                              }
                                            },
                                          },
                                        ]}
                                        initialValue={formValuesForStock?.min_dia_cutter}
                                        label="Min Dia"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Min Dia"
                                          onChange={() => validateFieldsOnChange(["min_dia_cutter", "max_dia_cutter"])}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div className="boxFormType" style={{ marginBottom: "0" }}>
                                      <Form.Item
                                        name="max_dia_cutter"
                                        rules={[
                                          {
                                            pattern: new RegExp(/^(?!0(?:\.0+)?$)\d+(?:\.\d+)?$/),
                                            message: "Only numerical non-zero values are allowed",
                                          },
                                          {
                                            validator(_, value) {
                                              if (value < parseFloat(form.getFieldValue("min_dia_cutter"))) {
                                                // return Promise.reject("Max dia cannot be less than min dia");
                                              } else {
                                                return Promise.resolve();
                                              }
                                            },
                                          },
                                        ]}
                                        initialValue={formValuesForStock?.max_dia_cutter}
                                        label="Max Dia"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Max Dia"
                                          onChange={() => validateFieldsOnChange(["min_dia_cutter", "max_dia_cutter"])}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType unitSelect"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="reel_dia_unit_cutter"
                                        rules={
                                          [
                                            // {
                                            //   required: true,
                                            //   message: "This is a required field",
                                            // },
                                          ]
                                        }
                                        label="Unit"
                                        className="dBlock"
                                        initialValue={
                                          formValuesForStock?.units_cutter
                                            ?.maximum_reel_dia
                                        }
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                        // onChange={() => {
                                        //   changeDeckleLength();
                                        // }}
                                        >
                                          {unitData?.units_management.length.data.map(
                                            (deckleWidth) => (
                                              <Option key={deckleWidth}>
                                                {
                                                  lengthUnit[deckleWidth]
                                                    .displayName
                                                }
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row> </PaperBlockList><PaperBlockList>
                                <Row className="centerAlign">
                                  <Col span={12}>
                                    <div className="boxFieldTitleMulti removeStar">
                                      <label>
                                        Maximum Trim on Intermediate Reel
                                      </label>
                                      <p>
                                        Specify the maximum trim other than edge
                                        trims allowed on intermediate reel. This
                                        will be used only when minimum size that
                                        can be cut on a cutter can't be achieved
                                        without adding some trim.
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="d-flex twoFields">
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="max_trim_intermediate_cutter"
                                        rules={[
                                          // {
                                          //   required: true,
                                          //   message: "This is a required field",
                                          // },
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only numerical values are allowed",
                                          },
                                        ]}
                                        initialValue={
                                          formValuesForStock?.max_trim_intermediate_cutter
                                        }
                                        label="Max Trim"
                                        className="dBlock"
                                      >
                                        <Input
                                          placeholder="Max Trim"
                                        // onChange={() => {
                                        //   changeDeckleLength();
                                        // }}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div
                                      className="boxFormType unitSelect"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name="max_trim_intermediate_unit_cutter"
                                        // rules={[
                                        //   {
                                        //     required: true,
                                        //     message: "This is a required field",
                                        //   },
                                        // ]}
                                        label="Unit"
                                        className="dBlock"
                                        initialValue={
                                          formValuesForStock?.units_cutter
                                            ?.allowed_trim ||
                                          unitData?.units_management?.length
                                            .default
                                        }
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                        // onChange={() => {
                                        //   changeDeckleLength();
                                        // }}
                                        >
                                          {unitData?.units_management.length.data.map(
                                            (deckleWidth) => (
                                              <Option key={deckleWidth}>
                                                {
                                                  lengthUnit[deckleWidth]
                                                    .displayName
                                                }
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                              </PaperBlockList>
                            </Col>
                          </Row>
                        </CollapsePanel>
                      </Collapse>
                    </div>
                  </HaberForm>
                </DetailFields>
              </Panes>
              <Panes tab="Orders" key="3">
                <OrdersTable
                  ordersIdList={ordersIdList}
                  // jobCardDetails={jobCardDetails}
                  unselectedOrdersList={unselectedOrders}
                  groupId={jobCardDetails?.group?.group_id}
                  isReelChanged={isSheetReelChanged}
                  machineData={machineData}
                  jobId={jobId}
                  jobCardDetails={(solutionId == '3' || solutionId == '4') ? completeJCDetails?.newlyCreatedJobCardsDetails?.[0]?.jobcard || jobCardDetails : jobCardDetails}
                  updateOrderIdList={(updatedOrderIds) => {
                    setOrderIdList(updatedOrderIds);
                    updateOrdersIdList && updateOrdersIdList(updatedOrderIds);
                  }}
                  onClickSetToleranceButton={onClickSetToleranceButton}
                  visible={toleranceModal}
                  setGlobalTolerance={setGlobalTolerance}
                  globalTolerance={globalTolerance}
                  setShowAlert={setShowAlert}
                  showAlert={showAlert}
                  setGlobalReelOD={setGlobalReelOD}
                  isJobCardReelODEditModal={isJobCardReelODEditModal}
                  setJobCardReelODEditModal={setJobCardReelODEditModal}
                  isFailedJobcard={isFailedJobcard}
                />
              </Panes>
              <Panes tab="Optimization Settings" key="4">
                <DetailFields>
                  <HaberForm>
                    <Row style={{ margin: "20px 0 0 10px" }}>
                      <Col span={12}>
                        <label>
                          <h2>Optimization Criteria</h2>
                        </label>
                        <span>
                          Select the optimization criteria for creating a new
                          solution
                        </span>
                      </Col>
                      <Col
                        span={12}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          height: "61vh",
                        }}
                      >
                        <Row
                          style={{ alignItems: "center", marginBottom: "10px" }}
                        >
                          <Col span={18}>
                            <label>Minimize Unique Combinations</label>
                            <Col span={20}>
                              <p>
                                You can choose to minimize the number of unique
                                combinations and save on setup time by enabling
                                this optimization criteria.
                              </p>
                            </Col>
                          </Col>
                          <Col span={6} style={{ textAlign: "right" }}>
                            <Switch
                              style={{
                                backgroundColor: optimizePartition
                                  ? "#EA655B"
                                  : "#A19F9D",
                              }}
                              onChange={handleSwitchChange2}
                              checked={optimizePartition}
                              className="switch-new"
                            />
                          </Col>
                        </Row>
                        <Row
                          style={{ alignItems: "center", marginBottom: "10px" }}
                        >
                          <Col span={18}>
                            <label>Minimize Trim Loss</label>
                            <Col span={20}>
                              <p>
                                The system tries to minimize trim loss by
                                default.
                              </p>
                            </Col>
                          </Col>
                          <Col span={6} style={{ textAlign: "right" }}>
                            <div className="boxFormType">
                              {/* <Form.item
                                name="optimizie_partitions"
                                // initialValue={optimizePartition}
                              > */}
                              <Switch
                                style={{
                                  backgroundColor: "#EA655B",
                                }}
                                className="switch-new"
                                disabled
                                checked={true}
                              />{" "}
                              {/* </Form.item> */}
                            </div>
                          </Col>
                        </Row>
                        <Row
                          style={{ alignItems: "center", marginBottom: "10px" }}
                        >
                          <Col span={18}>
                            <label>Maximize Fulfilment</label>
                            <Col span={20}>
                              <p>
                                The system tries to maximize fulfilment by
                                default.
                              </p>
                            </Col>
                          </Col>
                          <Col span={6} style={{ textAlign: "right" }}>
                            <div className="boxFormType">
                              <Switch
                                style={{
                                  backgroundColor: "#EA655B",
                                }}
                                disabled
                                checked={true}
                                className="switch-new"
                              />{" "}
                            </div>
                          </Col>
                        </Row>
                        <Row
                          style={{ alignItems: "center", marginBottom: "10px" }}
                        >
                          <Col span={18}>
                            <label>Minimize Overfulfilment</label>
                            <Col span={20}>
                              <p>
                                You can choose to minimize over fulfilment by
                                enabling this optimization criteria but it might
                                affect your fulfilment percentage, number of
                                combinations or trim loss.
                              </p>
                            </Col>
                          </Col>
                          <Col span={6} style={{ textAlign: "right" }}>
                            <Switch
                              style={{
                                backgroundColor: minimizeOverfulfillment
                                  ? "#EA655B"
                                  : "#A19F9D",
                              }}
                              onChange={handleSwitchChange3}
                              checked={minimizeOverfulfillment}
                              className="switch-new"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </HaberForm>
                </DetailFields>
              </Panes>
            </Tabs>
          </StyledTab>
        </div>
      </Form>
      {sizeErrorToastr && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={"Stock size already exist."}
        />
      )}
      {orderToastr && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={"At least one order need to exist in a solution."}
        />
      )}
    </RightLayoutContainer>
  );
  // ) : null;
};
export default CreateNewSolutionMultistage;
